import "core-js/modules/es.reflect.construct.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.object.values.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import _toConsumableArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _initializerDefineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _applyDecoratedDescriptor from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor";

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

import { makeObservable, observable, runInAction, reaction, computed, action } from "mobx";
import Base from "./Base";
import OrderInstructionModel from "./models/OrderInstructionModel";
import DPServices, { UserTypes } from "@dp/services";
import i18next from "i18next";
import PickupInfoModel from "./models/PickupInfoModel";
import PickupMethodModel from "./models/PickupMethodModel";
import ContactInfoModel from "./models/ContactInfoModel";
import LocationModel from "./models/LocationModel";
import BreadSticksModel from "./models/BreadSticksModel";
import { handle, Logger, toBoolean, getNoOfDaysBetween, extractFromFullName, getEnvProps, ORDER_TYPES, PlatformType, ERRORS, formatPhoneNumber, formatDate, formatAMPM, getLocalISODateString, getUnavailableItemsForError, isTrue, ERROR_RESPONSE_STATUS_CODE, TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES } from "@dp/common";
import AgeConfirmModel from "./models/AgeConfirmModel";
import TimeModel from "./models/TimeModel";
import { OnlinePaymentTypes, FallbackReasonCode, PaymentMethods, PickupMethod, PaymentFlow, CheckoutDialogueCodes, TOGO_DELIVERY_ERROR_POP_UP_TYPE } from "../utils";
import moment from "moment-timezone";
import Errors, { ERROR_STRINGS } from "./Errors";
import { UnavailableItemsModel } from "./models";
export var FETCH_TIME_TYPE;

(function (FETCH_TIME_TYPE) {
  FETCH_TIME_TYPE["PICKUP_FLOW"] = "pickup-flow";
  FETCH_TIME_TYPE["NEW_LOCATION"] = "new-location";
  FETCH_TIME_TYPE["USER_ACTION"] = "user-action";
  FETCH_TIME_TYPE["DINE_IN_FLOW"] = "dine-in-flow";
  FETCH_TIME_TYPE["PICKUP_SWITCH"] = "delivery-or-dipo-to-pickup";
})(FETCH_TIME_TYPE || (FETCH_TIME_TYPE = {}));

var Checkout = (_class = /*#__PURE__*/function (_Base) {
  _inherits(Checkout, _Base);

  var _super = _createSuper(Checkout); //Non observed values
  //Add all models for checkout here.


  function Checkout(rootStore) {
    var _this$rootStore3, _this$rootStore3$user;

    var _this;

    _classCallCheck(this, Checkout);

    _this = _super.call(this);

    _defineProperty(_assertThisInitialized(_this), "rootStore", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "cartOrder", _descriptor, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "formState", _descriptor2, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "orderInstructionModel", null);

    _defineProperty(_assertThisInitialized(_this), "pickupInfoModel", null);

    _defineProperty(_assertThisInitialized(_this), "pickupMethodModel", null);

    _defineProperty(_assertThisInitialized(_this), "contactInfoModel", null);

    _defineProperty(_assertThisInitialized(_this), "locationModel", null);

    _defineProperty(_assertThisInitialized(_this), "breadSticksModel", null);

    _defineProperty(_assertThisInitialized(_this), "timeModel", null);

    _defineProperty(_assertThisInitialized(_this), "appMessages", null);

    _defineProperty(_assertThisInitialized(_this), "payment", null);

    _defineProperty(_assertThisInitialized(_this), "unavailableItemsModel", null);

    _defineProperty(_assertThisInitialized(_this), "analyticsModel", void 0);

    _initializerDefineProperty(_assertThisInitialized(_this), "appAttributes", _descriptor3, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "checkoutAttributes", _descriptor4, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "result", _descriptor5, _assertThisInitialized(_this));

    _initializerDefineProperty(_assertThisInitialized(_this), "setPickResult", _descriptor6, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "ageConfirmModel", void 0);

    _defineProperty(_assertThisInitialized(_this), "storeReactionsSetup", false);

    _initializerDefineProperty(_assertThisInitialized(_this), "_dialogueCode", _descriptor7, _assertThisInitialized(_this));

    _defineProperty(_assertThisInitialized(_this), "applyBagFee", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _this$rootStore, _this$rootStore$user, _this$cartOrder, _cart$response, JWT_TOKEN, cart, _cart$response2;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return (_this$rootStore = _this.rootStore) === null || _this$rootStore === void 0 ? void 0 : (_this$rootStore$user = _this$rootStore.user) === null || _this$rootStore$user === void 0 ? void 0 : _this$rootStore$user.getTokenSilentIfLoggedIn();

            case 3:
              JWT_TOKEN = _context.sent;
              _context.next = 6;
              return DPServices.Cart.applyBagFee({
                orderId: (_this$cartOrder = _this.cartOrder) === null || _this$cartOrder === void 0 ? void 0 : _this$cartOrder.orderId
              }, JWT_TOKEN);

            case 6:
              cart = _context.sent;

              if (cart !== null && cart !== void 0 && (_cart$response = cart.response) !== null && _cart$response !== void 0 && _cart$response.order) {
                _this.orderInstructionModel.isBagFeeSelected = true; // TODO(APPLY_BAG_FEE): cloud type issues
                // @ts-ignore

                _this._processCartResponse(cart === null || cart === void 0 ? void 0 : (_cart$response2 = cart.response) === null || _cart$response2 === void 0 ? void 0 : _cart$response2.order);
              }

              _context.next = 14;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](0);
              console.log(_context.t0);

              _this.appMessages.showError("Error", "Something went wrong, try again later.");

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 10]]);
    })));

    _defineProperty(_assertThisInitialized(_this), "removeBagFee", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var _this$rootStore2, _this$cartOrder2, _cart$response3, JWT_TOKEN, cart, _cart$response4;

      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (_this$rootStore2 = _this.rootStore) === null || _this$rootStore2 === void 0 ? void 0 : _this$rootStore2.user.getTokenSilentIfLoggedIn();

            case 3:
              JWT_TOKEN = _context2.sent;
              _context2.next = 6;
              return DPServices.Cart.removeBagFee((_this$cartOrder2 = _this.cartOrder) === null || _this$cartOrder2 === void 0 ? void 0 : _this$cartOrder2.orderId, JWT_TOKEN);

            case 6:
              cart = _context2.sent;

              if (cart !== null && cart !== void 0 && (_cart$response3 = cart.response) !== null && _cart$response3 !== void 0 && _cart$response3.order) {
                _this.orderInstructionModel.isBagFeeSelected = false; // TODO(REMOVE_BAG_FEE): cloud type issues
                // @ts-ignore

                _this._processCartResponse(cart === null || cart === void 0 ? void 0 : (_cart$response4 = cart.response) === null || _cart$response4 === void 0 ? void 0 : _cart$response4.order);
              }

              _context2.next = 14;
              break;

            case 10:
              _context2.prev = 10;
              _context2.t0 = _context2["catch"](0);
              console.log(_context2.t0);

              _this.appMessages.showError("Error", "Something went wrong, try again later.");

            case 14:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[0, 10]]);
    })));

    _this.rootStore = rootStore;
    _this.appMessages = rootStore.appMessages;
    _this.payment = rootStore.payment;
    _this.analyticsModel = (_this$rootStore3 = _this.rootStore) === null || _this$rootStore3 === void 0 ? void 0 : (_this$rootStore3$user = _this$rootStore3.user) === null || _this$rootStore3$user === void 0 ? void 0 : _this$rootStore3$user.analyticsModel;
    _this.orderInstructionModel = new OrderInstructionModel(_this.rootStore.platformUtil);
    _this.pickupInfoModel = new PickupInfoModel(_this.rootStore.platformUtil);
    _this.pickupMethodModel = new PickupMethodModel();
    _this.contactInfoModel = new ContactInfoModel(_this.rootStore.platformUtil);
    _this.locationModel = new LocationModel();
    _this.breadSticksModel = new BreadSticksModel();

    if (_this.rootStore.menuList) {
      _this.timeModel = _this.rootStore.menuList.timeModel;
      _this.unavailableItemsModel = _this.rootStore.menuList.unavailableItemsModel;
    } else {
      _this.timeModel = new TimeModel(_this.rootStore.platformUtil);
      _this.unavailableItemsModel = new UnavailableItemsModel(_this.rootStore.platformUtil);
    }

    _this.ageConfirmModel = new AgeConfirmModel(_this.rootStore.platformUtil);
    _this.formState = {
      submitCount: 0,
      apiFiredCount: 0,
      isFailed: false,
      isSubmitting: false,
      isSuccess: false,
      _isQuoteValid: true,
      _isQuoteUpdated: false
    };
    _this.storeReactionsSetup = false;
    makeObservable(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(Checkout, [{
    key: "reset",
    value: function () {
      var _reset = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.orderInstructionModel.specialInstructions = "";
                this.ageConfirmModel.isOrderContainAlcoholItem = false;
                this.dialogueCode = null;
                runInAction(function () {
                  _this2.formState._isQuoteValid = true;
                  _this2.formState._isQuoteUpdated = false;
                });

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function reset() {
        return _reset.apply(this, arguments);
      }

      return reset;
    }()
  }, {
    key: "setupReactions",
    value: function setupReactions() {
      var _this3 = this;

      if (this.storeReactionsSetup) {
        return;
      } //app-init


      reaction(function () {
        return {
          appAttributes: _this3.rootStore.common.appAttributes
        };
      }, function (data) {
        _this3._processAppAttributes(data.appAttributes);
      });
      reaction(function () {
        return {
          submitCount: _this3.formState.submitCount
        };
      }, function (data) {
        var isSubmitted = data.submitCount > 0;
        _this3.payment.formSubmitted = isSubmitted;
      }); //session-details

      reaction(function () {
        return {
          sessionDetails: _this3.rootStore.user.sessionDetails
        };
      }, function (data) {
        _this3._processSessionDetails(data.sessionDetails);
      }); //times call

      reaction(function () {
        return {
          cartOrder: _this3.cartOrder
        };
      }, function (data) {
        var _data$cartOrder;

        if ((_data$cartOrder = data.cartOrder) !== null && _data$cartOrder !== void 0 && _data$cartOrder.restaurantNum) {
          _this3.fetchTimes();
        }
      });
      reaction(function () {
        return {
          isSmartPaySelected: _this3.payment.isSmartPaySelected
        };
      }, function (data) {
        _this3.contactInfoModel.isSmartPaySelected = data.isSmartPaySelected;
      }); //user-profile

      reaction(function () {
        return {
          userProfile: _this3.rootStore.user.userProfile,
          isLoggedIn: _this3.rootStore.user.isLoggedIn
        };
      }, function (data) {
        if (data.isLoggedIn) {
          _this3._processUserProfile(data.isLoggedIn, data.userProfile);
        }
      }); //PhoneNumber position based on pickup method

      reaction(function () {
        return {
          pickupMethod: _this3.pickupMethodModel.pickupMethod
        };
      }, function (data) {
        _this3._processPickupMethod(data.pickupMethod);
      }); //isValid reactions for mobile accordion

      reaction(function () {
        return {
          isOrderAndPickupStepValid: _this3.orderInstructionModel.isValid && _this3.pickupInfoModel.isValid
        };
      }, function (data) {
        runInAction(function () {
          _this3.rootStore.common.accordionModel.model.orderAndPickupStep.isValid = data.isOrderAndPickupStepValid;
        });
      });
      this.payment.creditCardInfo.registerOnCCNameChangeHandler(function (ccFirstName, ccLastName) {
        var isLoggedIn = _this3.rootStore.user.isLoggedIn;

        if (!isLoggedIn) {
          var contactInfoFirstName = _this3.contactInfoModel.fName;
          var contactInfoLastName = _this3.contactInfoModel.lName;

          if (ccFirstName && !contactInfoFirstName) {
            _this3.contactInfoModel.fName = ccFirstName;
          }

          if (ccLastName && !contactInfoLastName) {
            _this3.contactInfoModel.lName = ccLastName;
          }
        }
      });
      this.storeReactionsSetup = true;
      reaction(function () {
        return {
          isApplePaySelected: _this3.payment.activePaymentTab === PaymentMethods.ONLINE && _this3.payment.activeOtherOptionTab === OnlinePaymentTypes.APPLE_PAY
        };
      }, function (data) {
        _this3.contactInfoModel.isApplePaySelected = data.isApplePaySelected;
      }); // quote api needs to be called on change of #suite before the submit happens

      reaction(function () {
        var _this3$locationModel, _this3$locationModel$;

        return {
          suite: (_this3$locationModel = _this3.locationModel) === null || _this3$locationModel === void 0 ? void 0 : (_this3$locationModel$ = _this3$locationModel.deliveryAddress) === null || _this3$locationModel$ === void 0 ? void 0 : _this3$locationModel$.address2
        };
      }, function (data) {
        var _this3$cartOrder;

        if (((_this3$cartOrder = _this3.cartOrder) === null || _this3$cartOrder === void 0 ? void 0 : _this3$cartOrder.orderType) === ORDER_TYPES.TOGO_DELIVERY) {
          runInAction(function () {
            _this3.formState._isQuoteValid = false;
            _this3.formState._isQuoteUpdated = false;
          });
        }
      });
    }
  }, {
    key: "_processAppAttributes",
    value: function _processAppAttributes(appAttributes) {
      var _this4 = this;

      runInAction(function () {
        _this4.appAttributes = appAttributes;
      });

      if (appAttributes) {
        var _appAttributes$config; // Occation information for togo delivery order


        this.orderInstructionModel.occasionInfo = appAttributes === null || appAttributes === void 0 ? void 0 : appAttributes.deliveryOccasion; // This has been moved

        this.contactInfoModel.setAppAttributes(appAttributes);
        this.orderInstructionModel.setAppAttributes(appAttributes);
        this.pickupInfoModel.setAppAttributes(appAttributes);
        this.unavailableItemsModel.setAppAttributes(appAttributes);
        this.breadSticksModel.setAppAttributesData(appAttributes);
        runInAction(function () {
          _this4.appAttributes = appAttributes;
        });

        if (appAttributes.currentConceptCode) {
          //this.orderInstructionModel.includeSilverware = "yes";
          runInAction(function () {
            _this4.rootStore.common.accordionModel.model.orderAndPickupStep.isValid = _this4.orderInstructionModel.isValid && _this4.pickupInfoModel.isValid;
          });
        }

        var isPaypalToGoEnabled = appAttributes === null || appAttributes === void 0 ? void 0 : (_appAttributes$config = appAttributes.configs) === null || _appAttributes$config === void 0 ? void 0 : _appAttributes$config.isPaypalToGoEnabled;

        if (this.payment) {
          this.payment.requestPhoneNumberFromAppleOrGooglePay = true;
          this.payment.requestShippingFieldsFromAppleOrGooglePay = false;
          this.payment.creditCardInfo.fullAVSEnabled = false;
          this.payment.isPayPalEnabled = isPaypalToGoEnabled === "true";
          var configs = appAttributes.configs;
        }
      }

      this.timeModel.setAppAttributes(this.appAttributes); // TODO: Change this.
    }
  }, {
    key: "_processSessionDetails",
    value: function _processSessionDetails(sessionDetails) {
      var _this5 = this;

      if (sessionDetails) {
        runInAction(function () {
          var _sessionDetails$order;

          _this5.locationModel.locationDateTime.actualPickupDateTime = sessionDetails === null || sessionDetails === void 0 ? void 0 : (_sessionDetails$order = sessionDetails.orderContext) === null || _sessionDetails$order === void 0 ? void 0 : _sessionDetails$order.actualPickupDateTime;
        });
        this.orderInstructionModel.setSessionDetails(sessionDetails);
        runInAction(function () {
          _this5.locationModel.sessionDetails = sessionDetails;
        });
        this.timeModel.setSessionDetails(sessionDetails);
      }
    }
  }, {
    key: "_processUserProfile",
    value: function _processUserProfile(isLoggedIn, userProfile) {
      if (isLoggedIn && userProfile) {
        var _userProfile$defaultP;

        this.contactInfoModel.fName = userProfile.firstName;
        this.contactInfoModel.lName = userProfile.lastName;
        this.contactInfoModel.emailId = userProfile.login;
        var defaultPhoneNumber = (_userProfile$defaultP = userProfile.defaultPhone) === null || _userProfile$defaultP === void 0 ? void 0 : _userProfile$defaultP.phoneNumber;
        this.contactInfoModel.phoneNumber = formatPhoneNumber(defaultPhoneNumber);
        this.pickupInfoModel.curbSideMobile = formatPhoneNumber(defaultPhoneNumber);
        this.payment.creditCardInfo.fullAVSEnabled = true;
      }
    }
  }, {
    key: "_processPickupMethod",
    value: function _processPickupMethod(pickupMethod) {
      if (pickupMethod === PickupMethod.CARSIDE) {
        this.pickupInfoModel.openColor = false;
        this.pickupInfoModel.isCurbsidePickupSelected = true;
        this.payment.requestPhoneNumberFromAppleOrGooglePay = false;
        this.contactInfoModel.phoneNumberVisible = false;
      } else {
        this.contactInfoModel.phoneNumberVisible = true;
        this.pickupInfoModel.isCurbsidePickupSelected = false;
        this.payment.requestPhoneNumberFromAppleOrGooglePay = true;
      }
    }
  }, {
    key: "_processCartResponse",
    value: function () {
      var _processCartResponse2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(order) {
        var _order$shippingGroup, _this$rootStore$user$, _this$rootStore$user$2, orderType, restaurantNumber, _restaurantDetail$con, _zipValue$toString, _address$coordinates, _address$coordinates$, _address$coordinates2, _address$coordinates3, _restaurantDetail$fea, restaurantDetail, address, zipValue, location;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!order) {
                  _context4.next = 22;
                  break;
                }

                this.payment.orderPriceInfo = order === null || order === void 0 ? void 0 : order.priceInfo;
                this.payment.tippableAmount = order === null || order === void 0 ? void 0 : order.tippableAmount;
                this.payment.couponModel.appliedCouponCode = order === null || order === void 0 ? void 0 : order.couponDescription;
                this.payment.couponModel.couponDiscount = order === null || order === void 0 ? void 0 : order.couponDiscount;
                this.cartOrder = order;
                this.payment.subTotalWithoutItemDiscount = order.subTotalWithoutItemDiscount;
                this.breadSticksModel.cartItems = order.commerceItems;
                orderType = this.cartOrder.orderType;
                this.pickupInfoModel.isPickupEligible = orderType !== ORDER_TYPES.CATERING_DELIVERY; // Delivery Order

                this.orderInstructionModel.setTogoDeliveryQuote(order === null || order === void 0 ? void 0 : (_order$shippingGroup = order.shippingGroup) === null || _order$shippingGroup === void 0 ? void 0 : _order$shippingGroup.quote);
                restaurantNumber = (_this$rootStore$user$ = this.rootStore.user.sessionDetails) === null || _this$rootStore$user$ === void 0 ? void 0 : (_this$rootStore$user$2 = _this$rootStore$user$.restaurantDetails) === null || _this$rootStore$user$2 === void 0 ? void 0 : _this$rootStore$user$2.restaurantNumber;

                if (!restaurantNumber) {
                  _context4.next = 22;
                  break;
                }

                _context4.next = 15;
                return DPServices.Restaurant.getRestaurantDetailsByNumber(restaurantNumber);

              case 15:
                restaurantDetail = _context4.sent;
                this.analyticsModel.setRestaurantDetailData(restaurantDetail);
                address = restaurantDetail === null || restaurantDetail === void 0 ? void 0 : (_restaurantDetail$con = restaurantDetail.contactDetail) === null || _restaurantDetail$con === void 0 ? void 0 : _restaurantDetail$con.address;
                zipValue = address.zipCode ? address.zipCode : null;
                location = {
                  restaurantName: restaurantDetail === null || restaurantDetail === void 0 ? void 0 : restaurantDetail.restaurantName,
                  address1: address.street1,
                  address2: address.street2,
                  city: address.city,
                  state: address.stateCode,
                  zip: zipValue === null || zipValue === void 0 ? void 0 : (_zipValue$toString = zipValue.toString()) === null || _zipValue$toString === void 0 ? void 0 : _zipValue$toString.substring(0, 5),
                  phoneNumber: formatPhoneNumber(restaurantDetail.phoneNumber),
                  lat: address === null || address === void 0 ? void 0 : (_address$coordinates = address.coordinates) === null || _address$coordinates === void 0 ? void 0 : (_address$coordinates$ = _address$coordinates.latitude) === null || _address$coordinates$ === void 0 ? void 0 : _address$coordinates$.toString(),
                  lng: address === null || address === void 0 ? void 0 : (_address$coordinates2 = address.coordinates) === null || _address$coordinates2 === void 0 ? void 0 : (_address$coordinates3 = _address$coordinates2.longitude) === null || _address$coordinates3 === void 0 ? void 0 : _address$coordinates3.toString(),
                  countryCode: address === null || address === void 0 ? void 0 : address.countryCode,
                  resturantNumber: restaurantDetail === null || restaurantDetail === void 0 ? void 0 : restaurantDetail.restaurantNumber
                };
                this.locationModel.location = location;
                this.breadSticksModel.isBreadCountEnabled = restaurantDetail === null || restaurantDetail === void 0 ? void 0 : (_restaurantDetail$fea = restaurantDetail.features) === null || _restaurantDetail$fea === void 0 ? void 0 : _restaurantDetail$fea.breadCountEnable;

              case 22:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function _processCartResponse(_x) {
        return _processCartResponse2.apply(this, arguments);
      }

      return _processCartResponse;
    }()
  }, {
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var _this$rootStore4,
            _this$rootStore4$user,
            _this$rootStore5,
            _this$rootStore5$user,
            _this6 = this,
            _this$rootStore6,
            _this$rootStore6$comm,
            _this$rootStore7,
            _this$rootStore7$plat;

        var jwtToken, _yield$handle, _yield$handle2, err, checkoutAttributes, _yield$handle3, _yield$handle4, cartDetailsErr, cartDetailsResponse, errorUI;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return this.reset();

              case 2:
                _context6.next = 4;
                return handle(this.rootStore.platformUtil.hydrateUsingLocalStorage("CHECKOUT_CONTACT_INFO", this.contactInfoModel));

              case 4:
                _context6.next = 6;
                return handle(this.rootStore.platformUtil.hydrateUsingLocalStorage("CHECKOUT_PICKUP_INFO", this.pickupInfoModel));

              case 6:
                _context6.next = 8;
                return handle(this.rootStore.platformUtil.hydrateUsingSessionStorage(["ORDER_INS_INFO"].join("-"), this.orderInstructionModel));

              case 8:
                _context6.next = 10;
                return handle(this.rootStore.platformUtil.hydrateUsingSessionStorage(["CHECKOUT_PICKUP_METHOD"].join("-"), this.pickupMethodModel));

              case 10:
                this.payment = this.rootStore.payment;
                this.payment.flow = PaymentFlow.CHECKOUT;
                this.appMessages = this.rootStore.appMessages; //IMPORTANT: common store is already initialized before Checkout store

                this._processAppAttributes(this.rootStore.common.appAttributes);

                this._processSessionDetails(this.rootStore.user.sessionDetails);

                this._processUserProfile((_this$rootStore4 = this.rootStore) === null || _this$rootStore4 === void 0 ? void 0 : (_this$rootStore4$user = _this$rootStore4.user) === null || _this$rootStore4$user === void 0 ? void 0 : _this$rootStore4$user.isLoggedIn, (_this$rootStore5 = this.rootStore) === null || _this$rootStore5 === void 0 ? void 0 : (_this$rootStore5$user = _this$rootStore5.user) === null || _this$rootStore5$user === void 0 ? void 0 : _this$rootStore5$user.userProfile);

                this._processPickupMethod(this.pickupMethodModel.pickupMethod);

                if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
                  this.orderInstructionModel.showSpecialInstructions = true;
                } else {
                  this.orderInstructionModel.showSpecialInstructions = false;
                }

                _context6.next = 20;
                return this.rootStore.user.getTokenSilentIfLoggedIn();

              case 20:
                jwtToken = _context6.sent;
                _context6.next = 23;
                return handle(DPServices.Common.getCheckoutInitAttributes({
                  jwtToken: jwtToken
                }));

              case 23:
                _yield$handle = _context6.sent;
                _yield$handle2 = _slicedToArray(_yield$handle, 2);
                err = _yield$handle2[0];
                checkoutAttributes = _yield$handle2[1];

                if (err) {
                  this.appMessages.showError("Checkout", "Something went wrong. Please try again.", null, {
                    undismissible: true,
                    okBtnText: "Go Back",
                    okBtnOnClick: function okBtnOnClick() {
                      _this6.redirectToEmptyCartPage();
                    }
                  });
                } else {
                  if (checkoutAttributes) {
                    runInAction(function () {
                      var _checkoutAttributes$o;

                      if (!(checkoutAttributes !== null && checkoutAttributes !== void 0 && (_checkoutAttributes$o = checkoutAttributes.orderContext) !== null && _checkoutAttributes$o !== void 0 && _checkoutAttributes$o.checkCreated)) {
                        _this6.redirectToEmptyCartPage();
                      } else {
                        var _checkoutAttributes$o2, _checkoutAttributes$o3;

                        _this6.checkoutAttributes = checkoutAttributes;
                        var isCurbSideToGoAvailable = checkoutAttributes.isCurbSideToGoAvailable,
                            isInRestaurantPickupAvailable = checkoutAttributes.isInRestaurantPickupAvailable,
                            orderLockedForFraudSuspicion = checkoutAttributes.orderLockedForFraudSuspicion,
                            isCurbsideNotificationEnabled = checkoutAttributes.isCurbsideNotificationEnabled; //this.timeModel.setcheckoutAttributes(checkoutAttributes);

                        if (checkoutAttributes !== null && checkoutAttributes !== void 0 && (_checkoutAttributes$o2 = checkoutAttributes.orderContext) !== null && _checkoutAttributes$o2 !== void 0 && _checkoutAttributes$o2.isCartContainsAlcoholItem) {
                          _this6.ageConfirmModel.isOrderContainAlcoholItem = true;
                        }

                        _this6.payment.allowedPaymentMethods = _this6.checkoutAttributes.paymentMethods;

                        if (orderLockedForFraudSuspicion || (_checkoutAttributes$o3 = checkoutAttributes.orderContext) !== null && _checkoutAttributes$o3 !== void 0 && _checkoutAttributes$o3.orderLockedForFraudSuspicion) {
                          _this6.payment.isCCPaymentDisabled = true;
                        }

                        _this6.handleCurbsideAvailability(isCurbSideToGoAvailable, isInRestaurantPickupAvailable, isCurbsideNotificationEnabled);

                        _this6.orderInstructionModel.setCheckoutAttributes(checkoutAttributes);

                        if (checkoutAttributes.deliveryGroup) {
                          var _checkoutAttributes$d = checkoutAttributes.deliveryGroup,
                              address1 = _checkoutAttributes$d.address1,
                              address2 = _checkoutAttributes$d.address2,
                              city = _checkoutAttributes$d.city,
                              state = _checkoutAttributes$d.state,
                              postalCode = _checkoutAttributes$d.postalCode,
                              country = _checkoutAttributes$d.country;
                          var deliveryAddress = {
                            address1: address1,
                            address2: address2,
                            city: city,
                            state: state,
                            postalCode: postalCode,
                            country: country
                          };
                          _this6.locationModel.deliveryAddress = deliveryAddress;
                        }
                      }
                    });
                  }
                }

                _context6.next = 30;
                return handle(DPServices.Cart.getCartDetails({
                  orderId: (_this$rootStore6 = this.rootStore) === null || _this$rootStore6 === void 0 ? void 0 : (_this$rootStore6$comm = _this$rootStore6.common) === null || _this$rootStore6$comm === void 0 ? void 0 : _this$rootStore6$comm.orderID
                }, jwtToken));

              case 30:
                _yield$handle3 = _context6.sent;
                _yield$handle4 = _slicedToArray(_yield$handle3, 2);
                cartDetailsErr = _yield$handle4[0];
                cartDetailsResponse = _yield$handle4[1];

                if (cartDetailsErr) {
                  errorUI = DPServices.Common.handleUIErrorAndOverride(cartDetailsErr, {
                    title: ERROR_STRINGS.CART_GET_ORDER_DETAILS,
                    message: Errors.CART_GET_ORDER_DETAILS_FAILED.message
                  });
                  this.appMessages.showError(errorUI.title, errorUI.message, null, {
                    undismissible: true,
                    okBtnText: "Go Back",
                    okBtnOnClick: function okBtnOnClick() {
                      _this6.redirectToEmptyCartPage();
                    }
                  });
                } else {
                  runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                    var order;
                    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                      while (1) {
                        switch (_context5.prev = _context5.next) {
                          case 0:
                            order = cartDetailsResponse === null || cartDetailsResponse === void 0 ? void 0 : cartDetailsResponse.order;

                            if (order) {
                              _this6._processCartResponse(order);

                              _this6._setDefaultTipAndGratuityValues();

                              _this6.determinePaymentMethods();

                              _this6.analyticsModel.setCartData(order);
                            }

                          case 2:
                          case "end":
                            return _context5.stop();
                        }
                      }
                    }, _callee5);
                  })));
                } // set this to false so, nav back to menu will trigger smart rec modal again


                _context6.next = 37;
                return (_this$rootStore7 = this.rootStore) === null || _this$rootStore7 === void 0 ? void 0 : (_this$rootStore7$plat = _this$rootStore7.platformUtil) === null || _this$rootStore7$plat === void 0 ? void 0 : _this$rootStore7$plat.saveInSessionStorage("UPSELL_CHECKOUT_CONFIRMATION", "false");

              case 37:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function init() {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }, {
    key: "determinePaymentMethods",
    value: function determinePaymentMethods() {
      var _this$checkoutAttribu,
          _this7 = this;

      var sessionPaymentFlagInfo = (_this$checkoutAttribu = this.checkoutAttributes) === null || _this$checkoutAttribu === void 0 ? void 0 : _this$checkoutAttribu.paymentFlagInfo;
      var appAttributes = this.appAttributes;
      var appPaymentFlagInfo = appAttributes.paymentFlagInfo;
      var orderType = this.cartOrder.orderType;

      var _getEnvProps = getEnvProps(),
          NODE_ENV = _getEnvProps.NODE_ENV;

      var DEV_NODE_ENV = NODE_ENV === "development";

      if (orderType === ORDER_TYPES.CATERING_DELIVERY) {
        this.payment.isGooglePayEnabled = false;
        this.payment.isApplePayEnabled = false;
      } else {
        var _appPaymentFlagInfo$w, _appPaymentFlagInfo$w2, _sessionPaymentFlagIn, _sessionPaymentFlagIn2, _appPaymentFlagInfo$a, _appPaymentFlagInfo$g;

        var isApplePayTogoEnabledAtSiteLevel = DEV_NODE_ENV ? true : (_appPaymentFlagInfo$w = appPaymentFlagInfo === null || appPaymentFlagInfo === void 0 ? void 0 : appPaymentFlagInfo.webApplePay) !== null && _appPaymentFlagInfo$w !== void 0 ? _appPaymentFlagInfo$w : true;
        var isGooglePayTogoEnabledAtSiteLevel = DEV_NODE_ENV ? true : (_appPaymentFlagInfo$w2 = appPaymentFlagInfo === null || appPaymentFlagInfo === void 0 ? void 0 : appPaymentFlagInfo.webGooglePay) !== null && _appPaymentFlagInfo$w2 !== void 0 ? _appPaymentFlagInfo$w2 : true;
        var isApplePayTogoEnabledAtSessionLevel = DEV_NODE_ENV ? true : (_sessionPaymentFlagIn = sessionPaymentFlagInfo === null || sessionPaymentFlagInfo === void 0 ? void 0 : sessionPaymentFlagInfo.webApplePay) !== null && _sessionPaymentFlagIn !== void 0 ? _sessionPaymentFlagIn : true;
        var isGooglePayTogoEnabledAtSessionLevel = DEV_NODE_ENV ? true : (_sessionPaymentFlagIn2 = sessionPaymentFlagInfo === null || sessionPaymentFlagInfo === void 0 ? void 0 : sessionPaymentFlagInfo.webGooglePay) !== null && _sessionPaymentFlagIn2 !== void 0 ? _sessionPaymentFlagIn2 : true;
        var currentPickupTimestamp = this.timeModel.currentAPIPickupTime;
        var applePayPickupNoOfDaysThreshold = (_appPaymentFlagInfo$a = appPaymentFlagInfo === null || appPaymentFlagInfo === void 0 ? void 0 : appPaymentFlagInfo.applePayThresholdDays) !== null && _appPaymentFlagInfo$a !== void 0 ? _appPaymentFlagInfo$a : 0;
        var googlePayPickupNoOfDaysThreshold = (_appPaymentFlagInfo$g = appPaymentFlagInfo === null || appPaymentFlagInfo === void 0 ? void 0 : appPaymentFlagInfo.googlePayThresholdDays) !== null && _appPaymentFlagInfo$g !== void 0 ? _appPaymentFlagInfo$g : 0;
        var daysDiff = getNoOfDaysBetween(moment().toDate(), moment(currentPickupTimestamp).toDate());
        var applePayWithinThreshold = daysDiff <= applePayPickupNoOfDaysThreshold;
        var googlePayWithinThreshold = daysDiff <= googlePayPickupNoOfDaysThreshold;

        if (applePayWithinThreshold && isApplePayTogoEnabledAtSessionLevel && isApplePayTogoEnabledAtSiteLevel) {
          if (googlePayWithinThreshold && isGooglePayTogoEnabledAtSessionLevel && isGooglePayTogoEnabledAtSiteLevel) {
            // Both Available
            this.rootStore.refreshInProgress = true;
            Promise.all([this.rootStore.platformUtil.canMakeApplePayPayment(this.payment.applePayPaymentMerchantId), this.rootStore.platformUtil.canMakeGooglePayPayment(this.payment.googlePayIsReadyToPayRequest)]).then(function (_ref4) {
              var _ref5 = _slicedToArray(_ref4, 2),
                  canUseApplePay = _ref5[0],
                  canUseGooglePay = _ref5[1];

              _this7.rootStore.refreshInProgress = false;
              _this7.payment.isGooglePayEnabled = canUseGooglePay;
              _this7.payment.isApplePayEnabled = canUseApplePay;

              if (_this7.payment.activeOtherOptionTab === OnlinePaymentTypes.NONE) {
                if (canUseApplePay) {
                  _this7.payment.activeOtherOptionTab = OnlinePaymentTypes.APPLE_PAY;
                } else {
                  if (canUseGooglePay) {
                    _this7.payment.activeOtherOptionTab = OnlinePaymentTypes.GOOGLE_PAY;
                  } else {
                    if (!_this7.rootStore.isMobile) {
                      _this7.payment.activeOtherOptionTab = OnlinePaymentTypes.CREDIT_CARD;
                    }
                  }
                }
              }
            });
          } else {
            // Only Apple Pay
            this.rootStore.refreshInProgress = true;
            Promise.all([this.rootStore.platformUtil.canMakeApplePayPayment(this.payment.applePayPaymentMerchantId)]).then(function (_ref6) {
              var _ref7 = _slicedToArray(_ref6, 1),
                  canUseApplePay = _ref7[0];

              _this7.rootStore.refreshInProgress = false;
              _this7.payment.isApplePayEnabled = canUseApplePay;
              _this7.payment.isGooglePayEnabled = false;

              if (_this7.payment.activeOtherOptionTab === OnlinePaymentTypes.NONE || _this7.payment.activeOtherOptionTab === OnlinePaymentTypes.GOOGLE_PAY) {
                _this7.payment.activeOtherOptionTab = canUseApplePay ? OnlinePaymentTypes.APPLE_PAY : _this7.rootStore.isMobile ? OnlinePaymentTypes.NONE : OnlinePaymentTypes.CREDIT_CARD;
              }
            });
          }
        } else {
          if (googlePayWithinThreshold && isGooglePayTogoEnabledAtSessionLevel && isGooglePayTogoEnabledAtSiteLevel) {
            // Only Google Play
            this.rootStore.refreshInProgress = true;
            Promise.all([this.rootStore.platformUtil.canMakeGooglePayPayment(this.payment.googlePayIsReadyToPayRequest)]).then(function (_ref8) {
              var _ref9 = _slicedToArray(_ref8, 1),
                  canUseGooglePay = _ref9[0];

              _this7.rootStore.refreshInProgress = false;
              _this7.payment.isApplePayEnabled = false;
              _this7.payment.isGooglePayEnabled = canUseGooglePay;

              if (_this7.payment.activeOtherOptionTab === OnlinePaymentTypes.NONE || _this7.payment.activeOtherOptionTab === OnlinePaymentTypes.APPLE_PAY) {
                _this7.payment.activeOtherOptionTab = canUseGooglePay ? OnlinePaymentTypes.GOOGLE_PAY : _this7.rootStore.isMobile ? OnlinePaymentTypes.NONE : OnlinePaymentTypes.CREDIT_CARD;
              }
            });
          } else {
            //Neither
            this.payment.isApplePayEnabled = false;
            this.payment.isGooglePayEnabled = false;

            if (this.payment.activeOtherOptionTab === OnlinePaymentTypes.NONE || this.payment.activeOtherOptionTab === OnlinePaymentTypes.GOOGLE_PAY || this.payment.activeOtherOptionTab === OnlinePaymentTypes.APPLE_PAY) {
              var _this$payment, _this$payment$creditC;

              this.payment.activeOtherOptionTab = this.rootStore.isMobile || (_this$payment = this.payment) !== null && _this$payment !== void 0 && (_this$payment$creditC = _this$payment.creditCards) !== null && _this$payment$creditC !== void 0 && _this$payment$creditC.length ? OnlinePaymentTypes.NONE : OnlinePaymentTypes.CREDIT_CARD;
            }
          }
        }
      }
    }
  }, {
    key: "_setDefaultTipAndGratuityValues",
    value: function _setDefaultTipAndGratuityValues() {
      var configs = this.appAttributes.configs;

      if (this.cartOrder.orderType === ORDER_TYPES.TOGO_DELIVERY) {
        this.payment.gratuityModel.minTipPercentage = parseInt(configs.togo_delivery_min_tip_percentage) || 10;
        this.payment.gratuityModel.maxTipPercentage = parseInt(configs.togo_delivery_max_tip_percentage) || 25;
        this.payment.gratuityModel.tipLabelStep = parseInt(configs.togo_delivery_label_step) || 5;

        if (!this.payment.gratuityModel.selectedTipPercentage) {
          this.payment.gratuityModel.selectedTipPercentage = parseInt(configs.defaultTogoDeliveryTipPercentage) || 15;
        }
      } else {
        this.payment.gratuityModel.minTipPercentage = parseInt(configs.min_tip_percentage) || 0;
        this.payment.gratuityModel.maxTipPercentage = parseInt(configs.max_tip_percentage) || 25;
        this.payment.gratuityModel.tipLabelStep = parseInt(configs.max_tip_label_step) || 5;

        if (!this.payment.gratuityModel.selectedTipPercentage) {
          this.payment.gratuityModel.selectedTipPercentage = Number(configs === null || configs === void 0 ? void 0 : configs.defaultTipPercentage) || 15;
        }
      }
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function refresh() {
        return _refresh.apply(this, arguments);
      }

      return refresh;
    }()
  }, {
    key: "applyCoupon",
    value: function () {
      var _applyCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this$rootStore8,
            _this$rootStore8$user,
            _this8 = this;

        var couponModel, couponCode, orderId, JWT_TOKEN, _yield$handle5, _yield$handle6, err, couponResp, _err$errors, error;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                couponModel = this.payment.couponModel;
                couponCode = couponModel.couponCode;
                orderId = this.cartOrder.orderId;
                couponModel.isCouponLoading = true;
                _context8.next = 6;
                return (_this$rootStore8 = this.rootStore) === null || _this$rootStore8 === void 0 ? void 0 : (_this$rootStore8$user = _this$rootStore8.user) === null || _this$rootStore8$user === void 0 ? void 0 : _this$rootStore8$user.getTokenSilentIfLoggedIn();

              case 6:
                JWT_TOKEN = _context8.sent;
                _context8.next = 9;
                return handle(DPServices.Cart.applyCouponCode(orderId, couponCode === null || couponCode === void 0 ? void 0 : couponCode.trim(), JWT_TOKEN));

              case 9:
                _yield$handle5 = _context8.sent;
                _yield$handle6 = _slicedToArray(_yield$handle5, 2);
                err = _yield$handle6[0];
                couponResp = _yield$handle6[1];

                if (!err) {
                  if (couponResp) {
                    runInAction(function () {
                      var _couponResp$order, _couponResp$order2;

                      couponModel.isCouponValid = true;
                      couponModel.couponCode = ""; // Coupon Code will be present in the cart detail

                      var order = couponResp.order; // TODO(APPLY_COUPON): cloud type issues
                      // @ts-ignore

                      _this8._processCartResponse(order); // analyticd event


                      _this8.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "couponSuccess", {
                        couponCode: couponResp.order.couponCode ? couponResp.order.couponCode : "",
                        couponAmount: couponResp !== null && couponResp !== void 0 && (_couponResp$order = couponResp.order) !== null && _couponResp$order !== void 0 && _couponResp$order.couponDiscount ? Math.abs(couponResp === null || couponResp === void 0 ? void 0 : (_couponResp$order2 = couponResp.order) === null || _couponResp$order2 === void 0 ? void 0 : _couponResp$order2.couponDiscount) : 0,
                        couponMessage: "Coupon Code Applied"
                      });
                    });
                  } else {
                    // Failed to apply coupon code
                    couponModel.isCouponValid = false; // analyticd event

                    this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "couponFail", {
                      couponCode: couponCode ? couponCode : "",
                      couponMessage: i18next.t("error.coupon.invalid"),
                      errorCode: ""
                    });
                  }
                } else {
                  // @ts-ignore
                  error = err === null || err === void 0 ? void 0 : (_err$errors = err.errors) === null || _err$errors === void 0 ? void 0 : _err$errors[0]; // Failed to apply coupon code

                  couponModel.isCouponValid = false; // analyticd event

                  this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "couponFail", {
                    couponCode: couponCode ? couponCode : "",
                    couponMessage: (error === null || error === void 0 ? void 0 : error.message) || i18next.t("error.coupon.invalid"),
                    errorCode: (error === null || error === void 0 ? void 0 : error.code) || ""
                  });
                }

                couponModel.isCouponLoading = false;

              case 15:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this);
      }));

      function applyCoupon() {
        return _applyCoupon.apply(this, arguments);
      }

      return applyCoupon;
    }()
  }, {
    key: "removeCoupon",
    value: function () {
      var _removeCoupon = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var order, couponCode, orderId, _this$rootStore9, _this$rootStore9$user, JWT_TOKEN, _yield$handle7, _yield$handle8, err, couponResp, updatedOrder;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                order = this.cartOrder;
                couponCode = order.couponCode;
                orderId = this.cartOrder.orderId;

                if (!couponCode) {
                  _context9.next = 14;
                  break;
                }

                _context9.next = 6;
                return (_this$rootStore9 = this.rootStore) === null || _this$rootStore9 === void 0 ? void 0 : (_this$rootStore9$user = _this$rootStore9.user) === null || _this$rootStore9$user === void 0 ? void 0 : _this$rootStore9$user.getTokenSilentIfLoggedIn();

              case 6:
                JWT_TOKEN = _context9.sent;
                _context9.next = 9;
                return handle(DPServices.Cart.removeCouponCode(orderId, couponCode === null || couponCode === void 0 ? void 0 : couponCode.trim(), JWT_TOKEN));

              case 9:
                _yield$handle7 = _context9.sent;
                _yield$handle8 = _slicedToArray(_yield$handle7, 2);
                err = _yield$handle8[0];
                couponResp = _yield$handle8[1];

                if (!err) {
                  updatedOrder = couponResp.order; // TODO(REMOVE_COUPON): cloud type issues
                  // @ts-ignore

                  this._processCartResponse(updatedOrder);
                } else {// Failed to remove coupon code
                }

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function removeCoupon() {
        return _removeCoupon.apply(this, arguments);
      }

      return removeCoupon;
    }()
  }, {
    key: "onApplePayAuthorized",
    value: function () {
      var _onApplePayAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(event) {
        var setNewPickupTime,
            payment,
            proceed,
            result,
            success,
            faultCode,
            message,
            _args10 = arguments;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                setNewPickupTime = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : false;
                payment = event.payment;
                this.payment.applePayAuthorization = payment;

                if (!payment) {
                  _context10.next = 21;
                  break;
                }

                proceed = true;

                if (!setNewPickupTime) {
                  _context10.next = 9;
                  break;
                }

                _context10.next = 8;
                return this.setNewPickupTime();

              case 8:
                proceed = _context10.sent;

              case 9:
                if (!proceed) {
                  _context10.next = 18;
                  break;
                }

                _context10.next = 12;
                return this.submitOrder(false);

              case 12:
                result = _context10.sent;
                success = result.status === "SUCCESS";

                if (!success) {
                  this.payment.applePayAuthorization = null;
                  faultCode = result.faultCode;
                  message = this.decodeAuthError(result.reason);

                  if (faultCode && this.isSmartPayFailure(faultCode)) {
                    this.showSmartPayErrorMessage("Apple Pay", FallbackReasonCode.APPLEPAY_DP_FAILURE, message);
                  } else {
                    this.appMessages.showError("Apple Pay", message);
                  }
                }

                return _context10.abrupt("return", success);

              case 18:
                return _context10.abrupt("return", proceed);

              case 19:
                _context10.next = 23;
                break;

              case 21:
                this.appMessages.showError("Apple Pay", "Apple Pay authorization failed. Please try again.");
                return _context10.abrupt("return", false);

              case 23:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function onApplePayAuthorized(_x2) {
        return _onApplePayAuthorized.apply(this, arguments);
      }

      return onApplePayAuthorized;
    }()
  }, {
    key: "decodeAuthError",
    value: function decodeAuthError(reason) {
      if (reason) {
        if (reason === "REQUEST_TIMEOUT") {
          return "Your payment request has been timed out. Please try again.";
        } else {
          return reason;
        }
      } else {
        return reason;
      }
    }
  }, {
    key: "onGooglePayAuthorized",
    value: function () {
      var _onGooglePayAuthorized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(payment) {
        var setNewPickupTime,
            proceed,
            result,
            success,
            faultCode,
            _args11 = arguments;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                setNewPickupTime = _args11.length > 1 && _args11[1] !== undefined ? _args11[1] : false;
                this.payment.googlePayAuthorization = payment;

                if (!payment) {
                  _context11.next = 34;
                  break;
                }

                proceed = true;

                if (!setNewPickupTime) {
                  _context11.next = 8;
                  break;
                }

                _context11.next = 7;
                return this.setNewPickupTime();

              case 7:
                proceed = _context11.sent;

              case 8:
                if (!proceed) {
                  _context11.next = 31;
                  break;
                }

                _context11.next = 11;
                return this.submitOrder(false);

              case 11:
                result = _context11.sent;
                success = result.status === "SUCCESS";

                if (success) {
                  _context11.next = 28;
                  break;
                }

                this.payment.googlePayAuthorization = null;
                faultCode = result.faultCode;

                if (!(faultCode && this.isSmartPayFailure(faultCode))) {
                  _context11.next = 21;
                  break;
                }

                this.payment.fallbackReasonCode = FallbackReasonCode.GOOGLEPAY_DP_FAILURE;
                return _context11.abrupt("return", {
                  error: {
                    reason: "OTHER_ERROR",
                    message: this.decodeAuthError(result.reason) || "Failed to place order.",
                    intent: "PAYMENT_AUTHORIZATION"
                  },
                  transactionState: "ERROR"
                });

              case 21:
                if (!(faultCode && (faultCode.indexOf("PaymentService") === 0 || faultCode.indexOf("DRI") === 0))) {
                  _context11.next = 25;
                  break;
                }

                return _context11.abrupt("return", {
                  error: {
                    reason: "OTHER_ERROR",
                    message: this.decodeAuthError(result.reason) || "Failed to place order.",
                    intent: "PAYMENT_AUTHORIZATION"
                  },
                  transactionState: "ERROR"
                });

              case 25:
                return _context11.abrupt("return", {
                  transactionState: "SUCCESS"
                });

              case 26:
                _context11.next = 29;
                break;

              case 28:
                return _context11.abrupt("return", {
                  transactionState: "SUCCESS"
                });

              case 29:
                _context11.next = 32;
                break;

              case 31:
                return _context11.abrupt("return", {
                  transactionState: "SUCCESS"
                });

              case 32:
                _context11.next = 36;
                break;

              case 34:
                this.appMessages.showError("Google Pay", "Google Pay authorization failed. Please try again.");
                return _context11.abrupt("return", {
                  transactionState: "ERROR"
                });

              case 36:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function onGooglePayAuthorized(_x3) {
        return _onGooglePayAuthorized.apply(this, arguments);
      }

      return onGooglePayAuthorized;
    }()
  }, {
    key: "payPalSubmitOrder",
    value: function () {
      var _payPalSubmitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(approvalData, deviceData) {
        var processingError, merchantId, _yield$handle9, _yield$handle10, error;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (!(approvalData && deviceData)) {
                  _context12.next = 17;
                  break;
                }

                processingError = null; // Always use Partial MID for PayPal CORS request

                merchantId = this.appAttributes.partialAVSmerchantID;
                _context12.next = 5;
                return handle(this.payment.tokenizePayPalRSA(this.appAttributes.paymentCorrelationId, approvalData, deviceData, merchantId, "TOGO"));

              case 5:
                _yield$handle9 = _context12.sent;
                _yield$handle10 = _slicedToArray(_yield$handle9, 1);
                error = _yield$handle10[0];

                if (error) {
                  processingError = error;
                }

                if (!processingError) {
                  _context12.next = 13;
                  break;
                }

                this.appMessages.showError("PayPal Payment Failed", "PayPal authorization failed. Please try again.");
                _context12.next = 15;
                break;

              case 13:
                _context12.next = 15;
                return this.submitOrder(false);

              case 15:
                _context12.next = 18;
                break;

              case 17:
                this.appMessages.showError("PayPal Payment", "PayPal authorization failed. Please try again.");

              case 18:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function payPalSubmitOrder(_x4, _x5) {
        return _payPalSubmitOrder.apply(this, arguments);
      }

      return payPalSubmitOrder;
    }()
  }, {
    key: "payPalCancel",
    value: function () {
      var _payPalCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(errData) {
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                Logger.log(errData);

                if (this.payment.fallbackReasonCode === FallbackReasonCode.PAYPAL_DP_FAILURE) {
                  this.showSmartPayErrorMessage("PayPal", FallbackReasonCode.PAYPAL_DP_FAILURE);
                } else {
                  this.appMessages.showError("PayPal", "PayPal payment cancelled. Please try again.");
                }

              case 2:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this);
      }));

      function payPalCancel(_x6) {
        return _payPalCancel.apply(this, arguments);
      }

      return payPalCancel;
    }()
  }, {
    key: "payPalErrored",
    value: function () {
      var _payPalErrored = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(errData) {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                this.payment.payPalErrored = true;
                Logger.log(errData);
                this.showSmartPayErrorMessage("PayPal", FallbackReasonCode.PAYPAL_INIT_FAILURE);

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));

      function payPalErrored(_x7) {
        return _payPalErrored.apply(this, arguments);
      }

      return payPalErrored;
    }()
  }, {
    key: "applePayCancel",
    value: function () {
      var _applePayCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                if (this.payment.fallbackReasonCode === FallbackReasonCode.APPLEPAY_DP_FAILURE) {
                  this.showSmartPayErrorMessage("Apple Pay", FallbackReasonCode.APPLEPAY_DP_FAILURE);
                } else {
                  this.appMessages.showError("Apple " + (this.payment.requestPhoneNumberFromAppleOrGooglePay ? "Pay" : "pay"), "Apple Pay cancelled. Please try again.");
                }

              case 1:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));

      function applePayCancel() {
        return _applePayCancel.apply(this, arguments);
      }

      return applePayCancel;
    }()
  }, {
    key: "applePayErrored",
    value: function () {
      var _applePayErrored = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(errData) {
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                this.payment.applePayErrored = true;
                Logger.log(errData);
                this.showSmartPayErrorMessage("Apple Pay", FallbackReasonCode.APPLEPAY_INIT_FAILURE);

              case 3:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));

      function applePayErrored(_x8) {
        return _applePayErrored.apply(this, arguments);
      }

      return applePayErrored;
    }()
  }, {
    key: "googlePayCancel",
    value: function () {
      var _googlePayCancel = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(reason) {
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (this.payment.fallbackReasonCode === FallbackReasonCode.GOOGLEPAY_DP_FAILURE) {
                  this.showSmartPayErrorMessage("Google Pay", FallbackReasonCode.GOOGLEPAY_DP_FAILURE);
                } else {
                  this.appMessages.showError("Google Pay", "Google Pay cancelled. Please try again.");
                }

              case 1:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));

      function googlePayCancel(_x9) {
        return _googlePayCancel.apply(this, arguments);
      }

      return googlePayCancel;
    }()
  }, {
    key: "googlePayErrored",
    value: function () {
      var _googlePayErrored = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(errData) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                this.payment.googlePayErrored = true;
                Logger.log(errData);
                this.showSmartPayErrorMessage("Google Pay", FallbackReasonCode.GOOGLEPAY_INIT_FAILURE);

              case 3:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));

      function googlePayErrored(_x10) {
        return _googlePayErrored.apply(this, arguments);
      }

      return googlePayErrored;
    }()
  }, {
    key: "showSmartPayErrorMessage",
    value: function () {
      var _showSmartPayErrorMessage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(smartPayMethod, fallbackReasonCode) {
        var _this9 = this;

        var message,
            ENABLE_PAY_AT_REST,
            errorMessage,
            _args19 = arguments;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                message = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : "";
                ENABLE_PAY_AT_REST = this.cartOrder.orderType !== ORDER_TYPES.TOGO_DELIVERY;
                errorMessage = message + " " + i18next.t(ENABLE_PAY_AT_REST ? "label.smart_pay_failure_message" : "label.smart_pay_failure_message_no_pay_at_rest", {
                  defaultValue: ENABLE_PAY_AT_REST ? "Unfortunately, We are unable to process ${0} Payments right now. Would you like to Pay at Restaurant?" : "Unfortunately, We are unable to process ${0} Payments right now. Please try with a different payment method.",
                  interpolation: {
                    prefix: "${",
                    suffix: "}"
                  },
                  0: smartPayMethod
                });
                this.appMessages.showError(smartPayMethod, errorMessage, [], {
                  undismissible: true,
                  okBtnText: ENABLE_PAY_AT_REST ? "Yes, Place Order" : "Ok",
                  overrideModalProps: {
                    contentClassName: "finalPay"
                  },
                  cancelBtnText: ENABLE_PAY_AT_REST ? "Cancel" : null,
                  cancelBtnOnClick: function cancelBtnOnClick() {
                    _this9.payment.fallbackReasonCode = "";
                  },
                  okBtnOnClick: function okBtnOnClick() {
                    if (!ENABLE_PAY_AT_REST) {
                      return;
                    }

                    _this9.payment.fallbackReasonCode = fallbackReasonCode;
                    _this9.payment.activePaymentTab = PaymentMethods.PAY_AT_RESTAURANT;
                    _this9.payment.activeOtherOptionTab = OnlinePaymentTypes.NONE;

                    _this9.submitOrder(false);
                  }
                });

              case 4:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));

      function showSmartPayErrorMessage(_x11, _x12) {
        return _showSmartPayErrorMessage.apply(this, arguments);
      }

      return showSmartPayErrorMessage;
    }()
  }, {
    key: "isSmartPayFailure",
    value: function isSmartPayFailure(falutCode) {
      var smartPayFailure = false; //Technical Error
      // DRI-100 : service unavailable
      // DRI-102 : Connection Refused - While calling any backend service
      // DRI-103 : Read Timeout - While waiting for response of any backend service
      // DRI-104 : Invalid credentials
      // PaymentService-614 : Transaction is in progress with the service provider

      if (falutCode === "DRI-100" || falutCode === "DRI-102" || falutCode === "DRI-103" || falutCode === "DRI-104" || falutCode.indexOf("PaymentService") === 0 && falutCode === "PaymentService-614") {
        return true;
      }

      return smartPayFailure;
    }
  }, {
    key: "validateOrderDetails",
    value: function validateOrderDetails() {
      if (!this.isOrderDetailsValid) {
        var orderInstructionModel = this.orderInstructionModel,
            pickupInfoModel = this.pickupInfoModel,
            timeModel = this.timeModel;
        this.formState.submitCount = this.formState.submitCount + 1;
        this.rootStore.common.accordionModel.setFormSubmitted();

        if (!timeModel.isValid) {
          timeModel.handleInvalidModel(this.appMessages);
          return false;
        }

        if (!orderInstructionModel.isValid) {
          orderInstructionModel.handleInvalidModel(this.rootStore.isMobile);
          orderInstructionModel.setShowError(true);
          return false;
        }

        if (!pickupInfoModel.isValid) {
          pickupInfoModel.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          orderInstructionModel.setShowError(true);
          return false;
        }

        orderInstructionModel.setShowError(true);
        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "validateSubmitOrder",
    value: function validateSubmitOrder() {
      if (!this.isValid) {
        var _this$cartOrder3;

        var orderInstructionModel = this.orderInstructionModel,
            pickupInfoModel = this.pickupInfoModel,
            payment = this.payment,
            contactInfoModel = this.contactInfoModel,
            ageConfirmModel = this.ageConfirmModel,
            timeModel = this.timeModel;
        this.formState.submitCount = this.formState.submitCount + 1;
        this.rootStore.common.accordionModel.setFormSubmitted();

        if (!(contactInfoModel !== null && contactInfoModel !== void 0 && contactInfoModel.isPhoneValid)) {
          contactInfoModel.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          return false;
        }

        if (!timeModel.isValid) {
          timeModel.handleInvalidModel(this.appMessages);
          return false;
        }

        if (!orderInstructionModel.isValid) {
          orderInstructionModel.handleInvalidModel(this.rootStore.isMobile);
          return false;
        }

        if (!pickupInfoModel.isValid) {
          pickupInfoModel.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          return false;
        }

        if (!payment.isValid) {
          payment.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          return false;
        }

        if (!contactInfoModel.isValid) {
          contactInfoModel.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          return false;
        }

        if (!ageConfirmModel.isValid) {
          ageConfirmModel.handleInvalidModel(this.appMessages, this.rootStore.isMobile);
          return false;
        }

        if (((_this$cartOrder3 = this.cartOrder) === null || _this$cartOrder3 === void 0 ? void 0 : _this$cartOrder3.orderType) === ORDER_TYPES.TOGO_DELIVERY && !this.formState._isQuoteValid) {
          this._handleCreateQuote();
        }

        return false;
      } else {
        return true;
      }
    }
  }, {
    key: "processTheProcessingError",
    value: function processTheProcessingError(processingError) {
      var _this10 = this;

      var _getEnvProps2 = getEnvProps(),
          NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_FAILURE_IN_REST_PAYMENT_FALLBACK = _getEnvProps2.NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_FAILURE_IN_REST_PAYMENT_FALLBACK;

      var submitOrderResult = {
        status: "ERROR"
      };

      if (processingError) {
        submitOrderResult.faultCode = "CC_PROCESSING_ERROR";

        if (processingError === ERRORS.CC_TOKENIZATION_TECHNICAL_FAILURE || processingError === ERRORS.ERROR_SESSION_TOKEN_FAILURE || processingError === ERRORS.ERROR_TOKEN_UNKNOWN_FAULT_CASE || processingError === ERRORS.ERROR_MAX_ATTEMPTS_REACHED) {
          // FISERV TFault ERROR
          var ENABLE_PAY_AT_REST = processingError === ERRORS.ERROR_SESSION_TOKEN_FAILURE;

          if (this.cartOrder.orderType === ORDER_TYPES.TOGO_DELIVERY) {
            ENABLE_PAY_AT_REST = false;
          }

          if (toBoolean(NEXT_PUBLIC_REACT_APP_ORDER_SESSION_TOKEN_FAILURE_IN_REST_PAYMENT_FALLBACK, true)) {
            if (ENABLE_PAY_AT_REST) {
              this.payment.allowedPaymentMethods = "BOTH";
            }

            var message = "Unfortunately, We are unable to process Credit / Debit Card Payments right now.";
            var additionalMessage = "";

            if (this.cartOrder.orderType === ORDER_TYPES.TOGO_PICKUP) {
              var part1 = i18next.t("text.checkout.cardPaymentError.message.orderTogo.part1", {
                defaultValue: "Unfortunately, We are unable to process Credit / Debit Card Payments right now."
              });
              var part2 = ENABLE_PAY_AT_REST ? i18next.t("text.checkout.cardPaymentError.message.orderTogo.part2", {
                defaultValue: "Would you like to Pay at Restaurant?"
              }) : "";
              message = part1 + part2;
              additionalMessage = ENABLE_PAY_AT_REST ? i18next.t("text.checkout.cardPaymentError.additionalMessage.orderTogo", {
                defaultValue: "Please bring your Credit / Debit Card along with you when picking up the order."
              }) : "";
            } else if (this.cartOrder.orderType === ORDER_TYPES.CATERING_DELIVERY || this.cartOrder.orderType === ORDER_TYPES.CATERING_PICKUP) {
              var _part = i18next.t("text.checkout.cardPaymentError.message.orderCatering.part1", {
                defaultValue: "Unfortunately, We are unable to process Credit / Debit Card Payments right now."
              });

              var _part2 = ENABLE_PAY_AT_REST ? i18next.t("text.checkout.cardPaymentError.message.orderCatering.part2", {
                defaultValue: "Would you like to Pay at Restaurant?"
              }) : "";

              message = _part + _part2;
              additionalMessage = ENABLE_PAY_AT_REST ? i18next.t("text.checkout.cardPaymentError.additionalMessage.orderCatering", {
                defaultValue: "Please bring your Credit / Debit Card along with you when picking up the order."
              }) : "";
            }

            this.appMessages.showError("", message, [additionalMessage], {
              undismissible: false,
              okBtnText: ENABLE_PAY_AT_REST ? "Yes, Place Order" : "Ok",
              overrideModalProps: {
                contentClassName: "finalPay"
              },
              okBtnOnClick: function okBtnOnClick() {
                if (ENABLE_PAY_AT_REST) {
                  _this10.payment.fallbackReasonCode = FallbackReasonCode.ERROR_SESSION_TOKEN_FAILURE;
                  _this10.payment.activePaymentTab = PaymentMethods.PAY_AT_RESTAURANT;
                  _this10.payment.activeOtherOptionTab = OnlinePaymentTypes.NONE;

                  _this10.submitOrder(false);
                }
              }
            });
          } else {
            this.appMessages.showError("Credit Card", "Sorry, we're unable to process your request. Please verify card details and re-try or use a different card.");
          }
        } else if (processingError === ERRORS.CVV_VALIDATION_ERROR) {
          this.appMessages.showError("CVV validation", "Sorry, we're unable to process your request. Please verify your Security Code and re-try or use a different card.");
        } else if (processingError === ERRORS.CC_TOKENIZATION_BUSINESS_FAULT) {
          this.appMessages.showError("Credit Card", "Sorry, we're unable to process your request. Please verify card details and re-try or use a different card.");
        } else {
          submitOrderResult.faultCode = "PAYMENT_PROCESSING_ERROR";
          this.appMessages.showError("Checkout", "Cannot proceed with order submission. Please try again.");
        }
      } else {
        submitOrderResult.faultCode = "PAYMENT_PROCESSING_ERROR";
        this.appMessages.showError("Checkout", "Cannot proceed with order submission. Please try again.");
      }

      return submitOrderResult;
    }
  }, {
    key: "getCreditCardTokenizationAttributes",
    value: function getCreditCardTokenizationAttributes(isFullAVSEnabled) {
      return {
        merchantId: isFullAVSEnabled ? this.appAttributes.fullAVSmerchantID : this.appAttributes.partialAVSmerchantID,
        paymentCorrelationId: this.appAttributes.paymentCorrelationId,
        orderId: this.cartOrder.orderId
      };
    } // function is used to tokenize the credit-card number on completing the form

  }, {
    key: "tokenizeCreditCardAndHandleErrors",
    value: function () {
      var _tokenizeCreditCardAndHandleErrors = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
        var _this$getCreditCardTo, merchantId, orderId, paymentCorrelationId, _yield$handle11, _yield$handle12, processingError;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                if (this.payment.creditCardInfo.paymentToken) {
                  _context20.next = 9;
                  break;
                }

                _this$getCreditCardTo = this.getCreditCardTokenizationAttributes(this.payment.creditCardInfo.fullAVSEnabled), merchantId = _this$getCreditCardTo.merchantId, orderId = _this$getCreditCardTo.orderId, paymentCorrelationId = _this$getCreditCardTo.paymentCorrelationId;
                _context20.next = 4;
                return handle(this.payment.tokenizeCreditCardPayment(merchantId, paymentCorrelationId, orderId, "TOGO"));

              case 4:
                _yield$handle11 = _context20.sent;
                _yield$handle12 = _slicedToArray(_yield$handle11, 1);
                processingError = _yield$handle12[0];
                this.payment.creditCardInfo.resetCreditCardFormFlow();

                if (processingError) {
                  this.processTheProcessingError(processingError);
                }

              case 9:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this);
      }));

      function tokenizeCreditCardAndHandleErrors() {
        return _tokenizeCreditCardAndHandleErrors.apply(this, arguments);
      }

      return tokenizeCreditCardAndHandleErrors;
    }()
    /**
     *
     * @param pickupTime
     * @note quote data can be  retrieved: `orderInstructionModel.togoDeliveryQuote`
     * @returns {DELIVERY_TIME_UPDATED_USER_DECISION} An enum `DELIVERY_TIME_UPDATED_USER_DECISION` with the user's decision
     * @throws {GetQuoteUIError} if the data is not fetched
     */

  }, {
    key: "createQuote",
    value: function () {
      var _createQuote = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(pickupTime) {
        var _this$locationModel,
            _this$locationModel2,
            _this$locationModel2$,
            _this$cartOrder$shipp,
            _this11 = this;

        var deliveryAddress, quoteRequest, previousQuote, updatedQuote, userChoice;
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                deliveryAddress = (_this$locationModel = this.locationModel) === null || _this$locationModel === void 0 ? void 0 : _this$locationModel.deliveryAddress;
                quoteRequest = {
                  dropOffAddress: {
                    addressLine1: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.address1,
                    addressLine2: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.address2,
                    state: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.state,
                    city: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.city,
                    zipcode: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.postalCode,
                    country: deliveryAddress === null || deliveryAddress === void 0 ? void 0 : deliveryAddress.country
                  },
                  pickupRestaurantNumber: (_this$locationModel2 = this.locationModel) === null || _this$locationModel2 === void 0 ? void 0 : (_this$locationModel2$ = _this$locationModel2.location) === null || _this$locationModel2$ === void 0 ? void 0 : _this$locationModel2$.resturantNumber,
                  pickupDate: pickupTime.format("MM/DD/YYYY"),
                  pickupTime: pickupTime.format("hh:mm A"),
                  manifestTotal: (_this$cartOrder$shipp = this.cartOrder.shippingGroup) === null || _this$cartOrder$shipp === void 0 ? void 0 : _this$cartOrder$shipp.manifestTotal
                };
                previousQuote = this.orderInstructionModel.togoDeliveryQuote;
                _context21.next = 5;
                return DPServices.Delivery.getQuote(pickupTime, quoteRequest);

              case 5:
                updatedQuote = _context21.sent;
                runInAction(function () {
                  _this11.formState._isQuoteUpdated = true;
                  _this11.formState._isQuoteValid = true;
                });
                this.orderInstructionModel.setTogoDeliveryQuote(updatedQuote);
                this.rootStore.common.showDeliveryErrorPopUp(TOGO_DELIVERY_ERROR_POP_UP_TYPE.ERROR_TIME_UPDATED);
                _context21.next = 11;
                return this.rootStore.common.waitForUserChoiceTOGODeliveryTimeChange();

              case 11:
                userChoice = _context21.sent;
                return _context21.abrupt("return", userChoice);

              case 13:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));

      function createQuote(_x13) {
        return _createQuote.apply(this, arguments);
      }

      return createQuote;
    }()
  }, {
    key: "submitOrder",
    value: function () {
      var _submitOrder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(paymentAlreadyProcessed) {
        var _this12 = this;

        var orderInstructionModel, timeModel, isCheckExpired, isFlowTOGODelivery;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                orderInstructionModel = this.orderInstructionModel, timeModel = this.timeModel;
                isCheckExpired = this._validateIsCheckExpired();

                if (!isCheckExpired) {
                  _context23.next = 7;
                  break;
                }

                this.formState.isSubmitting = false;
                isFlowTOGODelivery = this.cartOrder.orderType === ORDER_TYPES.TOGO_DELIVERY;
                this.appMessages.showError(i18next.t(isFlowTOGODelivery ? "text.checkout.togoDelivery_checkExpired.title" : "text.checkout.checkExpired.title", {
                  defaultValue: "Session Expired"
                }), i18next.t(isFlowTOGODelivery ? "text.checkout.togoDelivery_checkExpired.subMessage" : "text.checkout.checkExpired.submessage", {
                  defaultValue: isFlowTOGODelivery ? "Due to inactivity, the time quoted for your delivery has expired. Please checkout again." : "Your Session has expired. Please checkout your cart again."
                }), null, {
                  undismissible: true,
                  okBtnText: "Ok",
                  okBtnOnClick: function okBtnOnClick() {
                    _this12._redirectToCartPage();
                  }
                });
                return _context23.abrupt("return", Promise.resolve({
                  status: "ERROR",
                  faultCode: "sessionExpired"
                }));

              case 7:
                return _context23.abrupt("return", new Promise(function (resolve) {
                  runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
                    var _timeModel$currentTim;

                    var valid, orderName, pickDateTime, processingError, guestCount, plateQty, bowlsQty, cupQty, submitOrderRequest, _this12$breadSticksMo, _this12$orderInstruct, _this12$appAttributes, _this12$appAttributes2, dfpSessionId, canProceedWithSubmitOrder, orderTotal, activePaymentTab, activePaymentOptionTab, inRestaurantPayment, gcPayments, savedCCPayment, merchantId, _yield$handle13, _yield$handle14, error, _this12$getCreditCard, _merchantId, orderId, paymentCorrelationId, _yield$handle15, _yield$handle16, _error, ccFormPayment, _paypalPayment$payPal, _paypalPayment$payPal2, _paypalPayment$payPal3, _paypalPayment$payPal4, _paypalPayment$payPal5, _paypalPayment$payPal6, _paypalPayment$payPal7, _paypalPayment$payPal8, _paypalPayment$payPal9, _paypalPayment$payPal10, _paypalPayment$payPal11, _paypalPayment$payPal12, _paypalPayment$payPal13, _paypalPayment$payPal14, _this12$payment, _this12$payment$payPa, _this12$payment$payPa2, _this12$payment2, _this12$payment2$payP, _this12$payment2$payP2, _this12$payment3, _this12$payment3$payP, _this12$payment3$payP2, _this12$payment4, _this12$payment4$payP, _this12$payment4$payP2, _this12$payment5, _this12$payment5$payP, _this12$payment5$payP2, _this12$payment6, _this12$payment6$payP, _this12$payment6$payP2, _this12$payment6$payP3, _paypalPayment$payPal15, _paypalPayment$payPal16, paypalPayment, _applePayment$billing, _applePayment$billing2, _applePayment$shippin, _applePayment$billing3, _applePayment$shippin2, applePayment, phoneNumber, emailAddress, _googlePayment$billin, googlePayAuthorization, googlePaymentPayload, googlePayment, _googlePayment$billin2, _googlePayment$billin3, _googlePayment$billin4, _googlePayment$billin5, _googlePayment$billin6, nameParts, _googlePayment$billin7, _googlePayment$billin8, _inRestaurantPayment, _this12$rootStore, _this12$rootStore$use, _this12$rootStore$use2, _this12$rootStore2, _this12$rootStore2$us, _this12$locationModel, _this12$locationModel2, _this12$locationModel3, jwtToken, resp, userProfile, submitOrderResult, _this12$cartOrder, result, _errorObj$errors, _errorObj$errors$, _result;

                    return _regeneratorRuntime.wrap(function _callee22$(_context22) {
                      while (1) {
                        switch (_context22.prev = _context22.next) {
                          case 0:
                            valid = _this12.validateSubmitOrder();
                            orderName = "Order Name " + _this12.cartOrder.orderId;
                            pickDateTime = moment(timeModel === null || timeModel === void 0 ? void 0 : (_timeModel$currentTim = timeModel.currentTimeSlot) === null || _timeModel$currentTim === void 0 ? void 0 : _timeModel$currentTim.startTimeInMs).toDate();
                            processingError = null;

                            if (!valid) {
                              _context22.next = 127;
                              break;
                            }

                            guestCount = orderInstructionModel.guestCount;
                            if (orderInstructionModel.cateringOrderPartysize) guestCount = orderInstructionModel.cateringOrderPartysize;
                            _context22.prev = 7;
                            _this12.formState.apiFiredCount = _this12.formState.apiFiredCount + 1;
                            runInAction(function () {
                              _this12.formState.isSubmitting = true;
                            });
                            plateQty = orderInstructionModel.plates ? guestCount || 1 : 0;
                            bowlsQty = orderInstructionModel.bowls ? guestCount || 1 : 0;
                            cupQty = orderInstructionModel.cups ? guestCount || 1 : 0;
                            submitOrderRequest = {
                              orderId: _this12.cartOrder.orderId,
                              carType: null,
                              carColor: null,
                              legalDrinkingAgeConfirmation: _this12.ageConfirmModel.isAgeConfirmed ? "yes" : "no",
                              // TODO: will Refactor this once BE removes the attribute dependency
                              // sending it as false based on cloud BE.
                              paymentAlreadyProcessed: false,
                              requestedPickupDate: formatDate(pickDateTime),
                              requestedPickupTime: formatAMPM(pickDateTime),
                              emailId: _this12.contactInfoModel.emailId,
                              instructions: orderInstructionModel.specialInstructions,
                              firstName: _this12.contactInfoModel.fName,
                              lastName: _this12.contactInfoModel.lName,
                              phoneNumber: _this12.pickupMethodModel.pickupMethod === PickupMethod.CARSIDE ? _this12.pickupInfoModel.curbSideMobile : _this12.contactInfoModel.phoneNumber,
                              phoneType: "Primary",
                              utensilsBean: {
                                noOfGuests: guestCount,
                                heatingKitIncluded: orderInstructionModel.heatingkit ? true : false,
                                silverwareQty: orderInstructionModel.includeSilverware ? guestCount || 1 : 0,
                                plateQty: plateQty,
                                bowlsQty: bowlsQty,
                                butterIncluded: orderInstructionModel.isBreadIncluded ? true : false,
                                cupQty: cupQty,
                                iceIncluded: orderInstructionModel.ice ? true : false,
                                silverwareIncluded: orderInstructionModel.isSilverWareShown ? true : false,
                                breadIncluded: "".concat(orderInstructionModel.isBreadIncluded),
                                condimentsList: !!orderInstructionModel.selectedCondiments ? orderInstructionModel.selectedCondiments : null,
                                platesIncluded: plateQty ? true : false,
                                bowlsIncluded: bowlsQty ? true : false,
                                cupsIncluded: cupQty ? true : false
                              },
                              totalBreadCount: "",
                              emailSignupSource: "",
                              brandOptin: false,
                              complaint: "",
                              confirmLocation: false,
                              carService: false,
                              confirmEmailId: _this12.contactInfoModel.emailId,
                              clientIp: "",
                              correlationId: "",
                              customerLocalDate: getLocalISODateString(moment().toDate()),
                              paymentCollection: []
                            };

                            if (_this12.cartOrder.orderType === ORDER_TYPES.TOGO_DELIVERY) {
                              submitOrderRequest.deliveryDropOffOption = orderInstructionModel.meetAtDoor ? "MEET_AT_MY_DOOR" : "LEAVE_AT_DOOR";
                              submitOrderRequest.driverInstructions = orderInstructionModel.driverInstructions;
                            }

                            if (_this12.breadSticksModel.isBreadCountEnabled) {
                              submitOrderRequest.totalBreadCount = (_this12$breadSticksMo = _this12.breadSticksModel.totalBreadCount) === null || _this12$breadSticksMo === void 0 ? void 0 : _this12$breadSticksMo.toString();
                            }

                            if (_this12.cartOrder.orderType === ORDER_TYPES.CATERING_DELIVERY) {
                              submitOrderRequest.deliveryOccasion = (_this12$orderInstruct = _this12.orderInstructionModel) === null || _this12$orderInstruct === void 0 ? void 0 : _this12$orderInstruct.occasionSelected;
                              submitOrderRequest.receiverName = _this12.pickupInfoModel.pickupPerson;
                              submitOrderRequest.receiverPhoneNumber = _this12.pickupInfoModel.pickupPersonMobile;
                              submitOrderRequest.deliveryInstruction = _this12.pickupInfoModel.deliveryDriverInfo;
                              delete submitOrderRequest.pickupName;
                            } else {
                              submitOrderRequest.pickupName = _this12.pickupInfoModel.pickupPerson;
                            }

                            if (_this12.pickupMethodModel.pickupMethod === PickupMethod.CARSIDE && (_this12.cartOrder.orderType === ORDER_TYPES.CATERING_PICKUP || _this12.cartOrder.orderType === ORDER_TYPES.TOGO_PICKUP)) {
                              submitOrderRequest.carColor = _this12.pickupInfoModel.vehicleColor;
                              submitOrderRequest.carType = _this12.pickupInfoModel.vehicleType;
                              submitOrderRequest.carService = !!(_this12.pickupInfoModel.vehicleColor && _this12.pickupInfoModel.vehicleType);
                            }

                            if (_this12.contactInfoModel.enableSpecialOffers && _this12.contactInfoModel.splOffer) {
                              submitOrderRequest.emailSignupSource = _this12.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP ? DPServices.Config.getSignUpSource("CHECKOUT").appSource : (_this12$appAttributes = _this12.appAttributes) === null || _this12$appAttributes === void 0 ? void 0 : (_this12$appAttributes2 = _this12$appAttributes.configs) === null || _this12$appAttributes2 === void 0 ? void 0 : _this12$appAttributes2.onlineorder_crm_signup_source;
                              submitOrderRequest.brandOptin = true;

                              if (_this12.contactInfoModel.showDOBFields && _this12.contactInfoModel.isDOBValid) {
                                submitOrderRequest.dobYear = _this12.contactInfoModel.eclubeYear;
                                submitOrderRequest.dobMonth = _this12.contactInfoModel.eclubeMonth;
                                submitOrderRequest.dobDay = _this12.contactInfoModel.eclubeDate;
                              }
                            } else {
                              submitOrderRequest.brandOptin = false;
                            }

                            _context22.next = 21;
                            return _this12.rootStore.platformUtil.getDFPSessionId();

                          case 21:
                            dfpSessionId = _context22.sent;

                            if (dfpSessionId) {
                              submitOrderRequest.correlationId = dfpSessionId;
                            }

                            canProceedWithSubmitOrder = true;
                            orderTotal = _this12.payment.orderTotalIncludingGratuity;

                            if (!(orderTotal > 0)) {
                              _context22.next = 68;
                              break;
                            }

                            activePaymentTab = _this12.payment.activePaymentTab;
                            activePaymentOptionTab = _this12.payment.activeOtherOptionTab;

                            if (!(activePaymentTab === PaymentMethods.PAY_AT_RESTAURANT)) {
                              _context22.next = 33;
                              break;
                            }

                            inRestaurantPayment = _this12.payment.payAtRestaurantPayload;
                            submitOrderRequest.paymentCollection.push(inRestaurantPayment);
                            _context22.next = 66;
                            break;

                          case 33:
                            // online payment
                            if (_this12.payment.isAnyGiftCardSelected) {
                              gcPayments = _this12.payment.gcPaymentPayload;
                              submitOrderRequest.paymentCollection.push(gcPayments);
                            }

                            if (_this12.payment.isSelectedGiftCardsSufficient) {
                              _context22.next = 66;
                              break;
                            }

                            if (!_this12.payment.isSavedCreditCardSelected) {
                              _context22.next = 49;
                              break;
                            } // Saved Credit Card selected


                            savedCCPayment = _this12.payment.savedCCPaymentPayload;

                            if (!savedCCPayment.paymentCVV) {
                              _context22.next = 45;
                              break;
                            }

                            merchantId = _this12.appAttributes.partialAVSmerchantID;
                            _context22.next = 41;
                            return handle(_this12.payment.validateSecurityCode(_this12.appAttributes.paymentCorrelationId, _this12.cartOrder.orderId, "TOGO", savedCCPayment, merchantId));

                          case 41:
                            _yield$handle13 = _context22.sent;
                            _yield$handle14 = _slicedToArray(_yield$handle13, 1);
                            error = _yield$handle14[0];

                            if (error) {
                              processingError = error;
                              canProceedWithSubmitOrder = false;
                            }

                          case 45:
                            delete savedCCPayment["paymentCVV"];
                            submitOrderRequest.paymentCollection.push({
                              transType: "TOG",
                              creditCards: [savedCCPayment]
                            });
                            _context22.next = 66;
                            break;

                          case 49:
                            if (!(activePaymentOptionTab === OnlinePaymentTypes.CREDIT_CARD)) {
                              _context22.next = 63;
                              break;
                            }

                            if (!_this12.payment.creditCardInfo.isValid) {
                              _context22.next = 62;
                              break;
                            }

                            if (_this12.payment.creditCardInfo.paymentToken) {
                              _context22.next = 59;
                              break;
                            }

                            _this12$getCreditCard = _this12.getCreditCardTokenizationAttributes(_this12.payment.creditCardInfo.fullAVSEnabled), _merchantId = _this12$getCreditCard.merchantId, orderId = _this12$getCreditCard.orderId, paymentCorrelationId = _this12$getCreditCard.paymentCorrelationId;
                            _context22.next = 55;
                            return handle(_this12.payment.tokenizeCreditCardPayment(_merchantId, paymentCorrelationId, orderId, "TOGO"));

                          case 55:
                            _yield$handle15 = _context22.sent;
                            _yield$handle16 = _slicedToArray(_yield$handle15, 1);
                            _error = _yield$handle16[0];

                            if (_error) {
                              processingError = _error;
                            }

                          case 59:
                            if (!_this12.payment.creditCardInfo.isCCError) {
                              ccFormPayment = _this12.payment.formCCPaymentPayload;
                              delete ccFormPayment["paymentCVV"];
                              submitOrderRequest.paymentCollection.push({
                                transType: "TOG",
                                creditCards: [ccFormPayment]
                              });
                            } else {
                              canProceedWithSubmitOrder = false;
                            }

                            _context22.next = 63;
                            break;

                          case 62:
                            canProceedWithSubmitOrder = false;

                          case 63:
                            if (activePaymentOptionTab === OnlinePaymentTypes.PAYPAL) {
                              if (_this12.payment.payPalData && _this12.payment.payPalData.tokenData) {
                                paypalPayment = _this12.payment.payPalPaymentPayload;
                                submitOrderRequest.paymentCollection.push({
                                  wallet: {
                                    transType: "PPP",
                                    billingInfo: {
                                      firstName: paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$payPal = paypalPayment.payPalPayment) === null || _paypalPayment$payPal === void 0 ? void 0 : _paypalPayment$payPal.firstName,
                                      lastName: paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$payPal2 = paypalPayment.payPalPayment) === null || _paypalPayment$payPal2 === void 0 ? void 0 : _paypalPayment$payPal2.lastName,
                                      email: paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$payPal3 = paypalPayment.payPalPayment) === null || _paypalPayment$payPal3 === void 0 ? void 0 : _paypalPayment$payPal3.email,
                                      phone: paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$payPal4 = paypalPayment.payPalPayment) === null || _paypalPayment$payPal4 === void 0 ? void 0 : _paypalPayment$payPal4.phone,
                                      line1: paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$payPal5 = paypalPayment.payPalPayment) === null || _paypalPayment$payPal5 === void 0 ? void 0 : (_paypalPayment$payPal6 = _paypalPayment$payPal5.billingAddress) === null || _paypalPayment$payPal6 === void 0 ? void 0 : _paypalPayment$payPal6.line1,
                                      city: paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$payPal7 = paypalPayment.payPalPayment) === null || _paypalPayment$payPal7 === void 0 ? void 0 : (_paypalPayment$payPal8 = _paypalPayment$payPal7.billingAddress) === null || _paypalPayment$payPal8 === void 0 ? void 0 : _paypalPayment$payPal8.city,
                                      postalCode: paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$payPal9 = paypalPayment.payPalPayment) === null || _paypalPayment$payPal9 === void 0 ? void 0 : (_paypalPayment$payPal10 = _paypalPayment$payPal9.billingAddress) === null || _paypalPayment$payPal10 === void 0 ? void 0 : _paypalPayment$payPal10.postalCode,
                                      state: paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$payPal11 = paypalPayment.payPalPayment) === null || _paypalPayment$payPal11 === void 0 ? void 0 : (_paypalPayment$payPal12 = _paypalPayment$payPal11.billingAddress) === null || _paypalPayment$payPal12 === void 0 ? void 0 : _paypalPayment$payPal12.state,
                                      countryCode: paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$payPal13 = paypalPayment.payPalPayment) === null || _paypalPayment$payPal13 === void 0 ? void 0 : (_paypalPayment$payPal14 = _paypalPayment$payPal13.billingAddress) === null || _paypalPayment$payPal14 === void 0 ? void 0 : _paypalPayment$payPal14.countryCode
                                    },
                                    transactionInfo: {
                                      cardAlias: parseInt((_this12$payment = _this12.payment) === null || _this12$payment === void 0 ? void 0 : (_this12$payment$payPa = _this12$payment.payPalData) === null || _this12$payment$payPa === void 0 ? void 0 : (_this12$payment$payPa2 = _this12$payment$payPa.tokenData) === null || _this12$payment$payPa2 === void 0 ? void 0 : _this12$payment$payPa2.alias, 10),
                                      expirationMonth: (_this12$payment2 = _this12.payment) === null || _this12$payment2 === void 0 ? void 0 : (_this12$payment2$payP = _this12$payment2.payPalData) === null || _this12$payment2$payP === void 0 ? void 0 : (_this12$payment2$payP2 = _this12$payment2$payP.tokenData) === null || _this12$payment2$payP2 === void 0 ? void 0 : _this12$payment2$payP2.expiryMonth,
                                      expirationYear: (_this12$payment3 = _this12.payment) === null || _this12$payment3 === void 0 ? void 0 : (_this12$payment3$payP = _this12$payment3.payPalData) === null || _this12$payment3$payP === void 0 ? void 0 : (_this12$payment3$payP2 = _this12$payment3$payP.tokenData) === null || _this12$payment3$payP2 === void 0 ? void 0 : _this12$payment3$payP2.expiryYear,
                                      firstName: paypalPayment.payPalPayment.firstName || " ",
                                      lastName: paypalPayment.payPalPayment.lastName || " ",
                                      paymentCardToken: parseInt((_this12$payment4 = _this12.payment) === null || _this12$payment4 === void 0 ? void 0 : (_this12$payment4$payP = _this12$payment4.payPalData) === null || _this12$payment4$payP === void 0 ? void 0 : (_this12$payment4$payP2 = _this12$payment4$payP.tokenData) === null || _this12$payment4$payP2 === void 0 ? void 0 : _this12$payment4$payP2.paypalToken, 10),
                                      nonce: (_this12$payment5 = _this12.payment) === null || _this12$payment5 === void 0 ? void 0 : (_this12$payment5$payP = _this12$payment5.payPalData) === null || _this12$payment5$payP === void 0 ? void 0 : (_this12$payment5$payP2 = _this12$payment5$payP.approvalData) === null || _this12$payment5$payP2 === void 0 ? void 0 : _this12$payment5$payP2.nonce,
                                      payerId: (_this12$payment6 = _this12.payment) === null || _this12$payment6 === void 0 ? void 0 : (_this12$payment6$payP = _this12$payment6.payPalData) === null || _this12$payment6$payP === void 0 ? void 0 : (_this12$payment6$payP2 = _this12$payment6$payP.approvalData) === null || _this12$payment6$payP2 === void 0 ? void 0 : (_this12$payment6$payP3 = _this12$payment6$payP2.details) === null || _this12$payment6$payP3 === void 0 ? void 0 : _this12$payment6$payP3.payerId
                                    },
                                    amount: paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$payPal15 = paypalPayment.payPalPayment) === null || _paypalPayment$payPal15 === void 0 ? void 0 : _paypalPayment$payPal15.amount,
                                    tipAmount: paypalPayment === null || paypalPayment === void 0 ? void 0 : (_paypalPayment$payPal16 = paypalPayment.payPalPayment) === null || _paypalPayment$payPal16 === void 0 ? void 0 : _paypalPayment$payPal16.tipAmount,
                                    currencyCode: "USD"
                                  }
                                });

                                if (!submitOrderRequest.firstName) {
                                  submitOrderRequest.firstName = paypalPayment.payPalPayment.firstName || " ";
                                }

                                if (!submitOrderRequest.lastName) {
                                  submitOrderRequest.lastName = paypalPayment.payPalPayment.lastName || " ";
                                }

                                if (!submitOrderRequest.phoneNumber) {
                                  submitOrderRequest.phoneNumber = paypalPayment.payPalPayment.phone;
                                }

                                if (!submitOrderRequest.emailId) {
                                  submitOrderRequest.emailId = paypalPayment.payPalPayment.email;
                                }

                                if (!submitOrderRequest.confirmEmailId) {
                                  submitOrderRequest.confirmEmailId = paypalPayment.payPalPayment.email;
                                }
                              } else {
                                canProceedWithSubmitOrder = false;
                              }
                            }

                            if (activePaymentOptionTab === OnlinePaymentTypes.APPLE_PAY) {
                              if (_this12.payment.applePayAuthorization) {
                                applePayment = _this12.payment.applePayAuthorization;

                                if ((_applePayment$billing = applePayment.billingContact) !== null && _applePayment$billing !== void 0 && _applePayment$billing.countryCode) {
                                  applePayment.billingContact.countryCode = applePayment.billingContact.countryCode.toUpperCase();
                                }

                                submitOrderRequest.paymentCollection.push({
                                  wallet: {
                                    transType: "APP",
                                    billingInfo: {
                                      addressLines: applePayment.billingContact.addressLines
                                    },
                                    administrativeArea: applePayment.billingContact.administrativeArea,
                                    country: applePayment.billingContact.country,
                                    countryCode: applePayment.billingContact.countryCode,
                                    familyName: applePayment.billingContact.familyName,
                                    givenName: applePayment.billingContact.givenName,
                                    locality: applePayment.billingContact.locality,
                                    phoneticFamilyName: applePayment.billingContact.phoneticFamilyName,
                                    phoneticGivenName: applePayment.billingContact.phoneticGivenName,
                                    postalCode: applePayment.billingContact.postalCode,
                                    subAdministrativeArea: applePayment.billingContact.subAdministrativeArea,
                                    subLocality: applePayment.billingContact.subLocality,
                                    transactionInfo: {
                                      paymentData: applePayment.token.paymentData,
                                      paymentMethod: applePayment.token.paymentMethod,
                                      transactionIdentifier: applePayment.token.transactionIdentifier
                                    },
                                    amount: _this12.payment.applePayPaymentPayload.applePayPayment.amount,
                                    tipAmount: _this12.payment.applePayPaymentPayload.applePayPayment.tipAmount,
                                    currencyCode: _this12.payment.applePayPaymentPayload.applePayPayment.currencyCode,
                                    sdkVersion: "EC_v1"
                                  }
                                });

                                if (!submitOrderRequest.firstName) {
                                  submitOrderRequest.firstName = applePayment.billingContact.givenName || " ";
                                }

                                if (!submitOrderRequest.lastName) {
                                  submitOrderRequest.lastName = applePayment.billingContact.familyName || " ";
                                }

                                phoneNumber = ((_applePayment$billing2 = applePayment.billingContact) === null || _applePayment$billing2 === void 0 ? void 0 : _applePayment$billing2.phoneNumber) || ((_applePayment$shippin = applePayment.shippingContact) === null || _applePayment$shippin === void 0 ? void 0 : _applePayment$shippin.phoneNumber);
                                emailAddress = ((_applePayment$billing3 = applePayment.billingContact) === null || _applePayment$billing3 === void 0 ? void 0 : _applePayment$billing3.emailAddress) || ((_applePayment$shippin2 = applePayment.shippingContact) === null || _applePayment$shippin2 === void 0 ? void 0 : _applePayment$shippin2.emailAddress);

                                if (phoneNumber && !submitOrderRequest.phoneNumber) {
                                  submitOrderRequest.phoneNumber = phoneNumber;
                                }

                                if (emailAddress && !submitOrderRequest.emailId) {
                                  submitOrderRequest.emailId = emailAddress;
                                }
                              } else {
                                canProceedWithSubmitOrder = false;
                              }
                            }

                            if (activePaymentOptionTab === OnlinePaymentTypes.GOOGLE_PAY) {
                              if (_this12.payment.googlePayAuthorization) {
                                googlePayAuthorization = _this12.payment.googlePayAuthorization;
                                googlePaymentPayload = _this12.payment.googlePayPaymentPayload;
                                submitOrderRequest.paymentCollection.push({
                                  wallet: {
                                    transType: "GP",
                                    billingInfo: {
                                      cardNetwork: googlePaymentPayload.googlePayPayment.billingInfo.cardNetwork,
                                      cardDetails: parseInt(googlePaymentPayload.googlePayPayment.billingInfo.cardDetails),
                                      billingAddress: {
                                        address3: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.address3,
                                        sortingCode: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.sortingCode,
                                        address2: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.address2,
                                        countryCode: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.countryCode,
                                        address1: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.address1,
                                        postalCode: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.postalCode,
                                        name: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.name,
                                        locality: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.locality,
                                        administrativeArea: googlePaymentPayload.googlePayPayment.billingInfo.billingAddress.administrativeArea
                                      }
                                    },
                                    transactionInfo: {
                                      description: googlePaymentPayload.googlePayPayment.transcationInfo.description,
                                      tokenizationData: googlePaymentPayload.googlePayPayment.transcationInfo.tokenizationData,
                                      type: googlePaymentPayload.googlePayPayment.transcationInfo.type
                                    },
                                    amount: googlePaymentPayload.googlePayPayment.amount,
                                    tipAmount: googlePaymentPayload.googlePayPayment.tipAmount,
                                    currencyCode: googlePaymentPayload.googlePayPayment.currencyCode,
                                    sdkVersion: "ECv1"
                                  }
                                });
                                googlePayment = googlePaymentPayload.googlePayPayment;

                                if ((_googlePayment$billin = googlePayment.billingInfo) !== null && _googlePayment$billin !== void 0 && _googlePayment$billin.billingAddress) {
                                  if ((_googlePayment$billin2 = googlePayment.billingInfo) !== null && _googlePayment$billin2 !== void 0 && (_googlePayment$billin3 = _googlePayment$billin2.billingAddress) !== null && _googlePayment$billin3 !== void 0 && _googlePayment$billin3.countryCode) {
                                    googlePayment.billingInfo.billingAddress.countryCode = googlePayment.billingInfo.billingAddress.countryCode.toUpperCase();
                                  }

                                  nameParts = extractFromFullName((_googlePayment$billin4 = googlePayment.billingInfo.billingAddress) === null || _googlePayment$billin4 === void 0 ? void 0 : _googlePayment$billin4.name);

                                  if (!submitOrderRequest.firstName) {
                                    submitOrderRequest.firstName = nameParts.first || " ";
                                  }

                                  if (!submitOrderRequest.lastName) {
                                    submitOrderRequest.lastName = nameParts.last || " ";
                                  }

                                  if ((_googlePayment$billin5 = googlePayment.billingInfo) !== null && _googlePayment$billin5 !== void 0 && (_googlePayment$billin6 = _googlePayment$billin5.billingAddress) !== null && _googlePayment$billin6 !== void 0 && _googlePayment$billin6.phoneNumber && !submitOrderRequest.phoneNumber) {
                                    submitOrderRequest.phoneNumber = (_googlePayment$billin7 = googlePayment.billingInfo) === null || _googlePayment$billin7 === void 0 ? void 0 : (_googlePayment$billin8 = _googlePayment$billin7.billingAddress) === null || _googlePayment$billin8 === void 0 ? void 0 : _googlePayment$billin8.phoneNumber;
                                  }
                                }

                                if (googlePayAuthorization.email && !submitOrderRequest.emailId) {
                                  submitOrderRequest.emailId = googlePayAuthorization.email;
                                }

                                if (googlePayAuthorization.email && !submitOrderRequest.confirmEmailId) {
                                  submitOrderRequest.confirmEmailId = googlePayAuthorization.email;
                                }
                              } else {
                                canProceedWithSubmitOrder = false;
                              }
                            }

                          case 66:
                            _context22.next = 70;
                            break;

                          case 68:
                            // Order Total is empty. Nothing to Pay.
                            _inRestaurantPayment = _this12.payment.payAtRestaurantPayload;
                            submitOrderRequest.paymentCollection.push(_inRestaurantPayment);

                          case 70:
                            if (!canProceedWithSubmitOrder) {
                              _context22.next = 95;
                              break;
                            }

                            if (_this12.cartOrder.orderType === ORDER_TYPES.TOGO_DELIVERY) {
                              if (_this12.formState._isQuoteUpdated) {
                                submitOrderRequest.quote = _this12.orderInstructionModel.togoDeliveryQuote;
                              } else {
                                delete submitOrderRequest["quote"];
                              }

                              if ((_this12$locationModel = _this12.locationModel) !== null && _this12$locationModel !== void 0 && (_this12$locationModel2 = _this12$locationModel.deliveryAddress) !== null && _this12$locationModel2 !== void 0 && (_this12$locationModel3 = _this12$locationModel2.address2) !== null && _this12$locationModel3 !== void 0 && _this12$locationModel3.length) {
                                submitOrderRequest.address2 = _this12.locationModel.deliveryAddress.address2;
                              } else {
                                delete submitOrderRequest["address2"];
                              }
                            }

                            _context22.next = 74;
                            return _this12.rootStore.user.getTokenSilentIfLoggedIn();

                          case 74:
                            jwtToken = _context22.sent;
                            _context22.next = 77;
                            return DPServices.Cart.submitOrder(submitOrderRequest, jwtToken);

                          case 77:
                            resp = _context22.sent;

                            if (_this12.contactInfoModel.enableSpecialOffers && _this12.contactInfoModel.splOffer) {
                              _this12.analyticsEclubCheck();
                            }

                            _context22.next = 81;
                            return _this12.cleanupAfterCheckoutSucess();

                          case 81:
                            resolve({
                              status: "SUCCESS"
                            });

                            if (!(_this12.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP && ((_this12$rootStore = _this12.rootStore) === null || _this12$rootStore === void 0 ? void 0 : (_this12$rootStore$use = _this12$rootStore.user) === null || _this12$rootStore$use === void 0 ? void 0 : (_this12$rootStore$use2 = _this12$rootStore$use.sessionDetails) === null || _this12$rootStore$use2 === void 0 ? void 0 : _this12$rootStore$use2.orderContext.orderTypeValue) !== ORDER_TYPES.TOGO_DELIVERY)) {
                              _context22.next = 85;
                              break;
                            }

                            _context22.next = 85;
                            return handle(_this12.createGeoFence(resp.checkReferencePOS, resp.orderId, submitOrderRequest.emailId));

                          case 85:
                            if ((_this12$rootStore2 = _this12.rootStore) !== null && _this12$rootStore2 !== void 0 && (_this12$rootStore2$us = _this12$rootStore2.user) !== null && _this12$rootStore2$us !== void 0 && _this12$rootStore2$us.isLoggedIn) {
                              _context22.next = 88;
                              break;
                            }

                            _context22.next = 92;
                            break;

                          case 88:
                            _context22.next = 90;
                            return _this12.rootStore.user.getCurrentUserProfile();

                          case 90:
                            userProfile = _context22.sent;
                            runInAction(function () {
                              _this12.rootStore.user.userProfile = userProfile;
                            });

                          case 92:
                            _this12.redirectToConfirmationPage(resp.orderId);

                            _context22.next = 99;
                            break;

                          case 95:
                            runInAction(function () {
                              _this12.formState.isSubmitting = false;
                              _this12.formState.isFailed = true;
                            });
                            submitOrderResult = _this12.processTheProcessingError(processingError); // analytics submit order failed event

                            _this12.analyticsFailedSubmitOrderEvent();

                            resolve(submitOrderResult);

                          case 99:
                            _context22.next = 125;
                            break;

                          case 101:
                            _context22.prev = 101;
                            _context22.t0 = _context22["catch"](7);

                            if (((_this12$cartOrder = _this12.cartOrder) === null || _this12$cartOrder === void 0 ? void 0 : _this12$cartOrder.orderType) === ORDER_TYPES.TOGO_DELIVERY) {
                              runInAction(function () {
                                _this12.formState._isQuoteValid = false;
                                _this12.formState._isQuoteUpdated = false;
                              });
                            }

                            if (!(_context22.t0 instanceof DPServices.Errors.UIError)) {
                              _context22.next = 115;
                              break;
                            }

                            _context22.next = 107;
                            return _this12.parseSubmitOrderAPIErrors(_context22.t0);

                          case 107:
                            result = _context22.sent;
                            _this12.formState.isSubmitting = false;
                            _this12.formState.isFailed = true; // analytics submit order failed event

                            _this12.analyticsFailedSubmitOrderEvent();

                            resolve(result);
                            return _context22.abrupt("return");

                          case 115:
                            if (!(_context22.t0 instanceof DPServices.Errors.GetQuoteUIError)) {
                              _context22.next = 121;
                              break;
                            }

                            _this12.rootStore.common.processCreateGetQuoteError(_context22.t0);

                            resolve({
                              status: "ERROR",
                              faultCode: _context22.t0 === null || _context22.t0 === void 0 ? void 0 : (_errorObj$errors = _context22.t0.errors) === null || _errorObj$errors === void 0 ? void 0 : (_errorObj$errors$ = _errorObj$errors[0]) === null || _errorObj$errors$ === void 0 ? void 0 : _errorObj$errors$.code
                            });
                            return _context22.abrupt("return");

                          case 121:
                            _result = {
                              status: "ERROR",
                              faultCode: "ORDER_PROCESSING_ERROR"
                            };

                            _this12.appMessages.showError("Error", "Unable to proceed with order submission. Please try again."); // analytics submit order failed event


                            _this12.analyticsFailedSubmitOrderEvent();

                            resolve(_result);

                          case 125:
                            _context22.next = 130;
                            break;

                          case 127:
                            _this12.formState.isSubmitting = false;

                            _this12.analyticsFailedSubmitOrderEvent();

                            resolve({
                              status: "ERROR",
                              faultCode: "FORM_INVALID"
                            });

                          case 130:
                          case "end":
                            return _context22.stop();
                        }
                      }
                    }, _callee22, null, [[7, 101]]);
                  })));
                }));

              case 8:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this);
      }));

      function submitOrder(_x14) {
        return _submitOrder.apply(this, arguments);
      }

      return submitOrder;
    }()
  }, {
    key: "_redirectToCartPage",
    value: function _redirectToCartPage() {
      if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
        this.rootStore.platformUtil.redirectToURL("/menu?opnSldr=true");
      } else {
        this.rootStore.platformUtil.navigateToRoute("/Cart");
      }
    }
  }, {
    key: "_validateIsCheckExpired",
    value: function _validateIsCheckExpired() {
      var _this$checkoutAttribu2, _this$checkoutAttribu3;

      var checkCreatedAt = (_this$checkoutAttribu2 = this.checkoutAttributes) === null || _this$checkoutAttribu2 === void 0 ? void 0 : (_this$checkoutAttribu3 = _this$checkoutAttribu2.orderContext) === null || _this$checkoutAttribu3 === void 0 ? void 0 : _this$checkoutAttribu3.checkCreatedAt;

      if (!!checkCreatedAt) {
        var checkCreatedAtMoment = moment.utc(checkCreatedAt); // Get the current time in UTC

        var currentTime = moment.utc(); // Add 15 minutes to the API time

        var threshold = checkCreatedAtMoment.add(this.checkExpirationThreshold, "minutes"); // Check if the current time is past the API time + 15 minutes

        return currentTime.isAfter(threshold);
      }

      return false;
    }
  }, {
    key: "parseSubmitOrderAPIErrors",
    value: function () {
      var _parseSubmitOrderAPIErrors = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(errorObj) {
        var _errorObj$errors2,
            _this13 = this;

        var error, result, isTOGODelivery, isErrorStatus_400, isErrorStatus_500, isCreateDeliveryFailed, isSubmitOrderGenericDeliveryError;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                error = errorObj === null || errorObj === void 0 ? void 0 : (_errorObj$errors2 = errorObj.errors) === null || _errorObj$errors2 === void 0 ? void 0 : _errorObj$errors2[0];
                result = {
                  status: "ERROR"
                };
                isTOGODelivery = this.cartOrder.orderType === ORDER_TYPES.TOGO_DELIVERY;

                if (!isTOGODelivery) {
                  _context24.next = 37;
                  break;
                }

                isErrorStatus_400 = (error === null || error === void 0 ? void 0 : error.statusCode) === ERROR_RESPONSE_STATUS_CODE.ERROR_400;
                isErrorStatus_500 = (error === null || error === void 0 ? void 0 : error.statusCode) === ERROR_RESPONSE_STATUS_CODE.ERROR_500;
                isCreateDeliveryFailed = (error === null || error === void 0 ? void 0 : error.code) === TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.CREATE_DELIVERY_FAILED;
                isSubmitOrderGenericDeliveryError = !Object.values(TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES).includes(error === null || error === void 0 ? void 0 : error.code);
                result.faultCode = error === null || error === void 0 ? void 0 : error.code;

                if (!(isCreateDeliveryFailed && isErrorStatus_500)) {
                  _context24.next = 14;
                  break;
                }

                this.rootStore.common.showDeliveryErrorPopUp(TOGO_DELIVERY_ERROR_POP_UP_TYPE.ERROR_DELIVERY_UNAVAILABLE);
                return _context24.abrupt("return", result);

              case 14:
                if (!(isSubmitOrderGenericDeliveryError && isErrorStatus_400)) {
                  _context24.next = 19;
                  break;
                }

                this.rootStore.common.showDeliveryErrorPopUp(TOGO_DELIVERY_ERROR_POP_UP_TYPE.ERROR_ORDER_FAILED);
                return _context24.abrupt("return", result);

              case 19:
                if (!((error === null || error === void 0 ? void 0 : error.code) === TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.DELIVERY_FLOW_PAYMENT_ERROR)) {
                  _context24.next = 24;
                  break;
                }

                this.rootStore.common.showDeliveryErrorPopUp(TOGO_DELIVERY_ERROR_POP_UP_TYPE.ERROR_PAYMENT_FAILED);
                return _context24.abrupt("return", result);

              case 24:
                if (!((error === null || error === void 0 ? void 0 : error.code) === TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.ERROR_REQUEST_FAILED_OR_TIMED_OUT)) {
                  _context24.next = 29;
                  break;
                }

                this.rootStore.common.showDeliveryErrorPopUp(TOGO_DELIVERY_ERROR_POP_UP_TYPE.ERROR_REQUEST_FAILED);
                return _context24.abrupt("return", result);

              case 29:
                if (!((error === null || error === void 0 ? void 0 : error.code) === TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.CHECK_NOT_FOUND_BY_ORDER_ID_OR_SESSION_ERROR)) {
                  _context24.next = 34;
                  break;
                }

                this.appMessages.showError(i18next.t("text.checkout.togoDelivery_checkExpired.title", {
                  defaultValue: "Session Expired"
                }), i18next.t("text.checkout.togoDelivery_checkExpired.subMessage", {
                  defaultValue: "Due to inactivity, the time quoted for your delivery has expired. Please checkout again."
                }), null, {
                  undismissible: true,
                  okBtnText: "Ok",
                  okBtnOnClick: function okBtnOnClick() {
                    _this13._redirectToCartPage();
                  }
                });
                return _context24.abrupt("return", result);

              case 34:
                if (!((error === null || error === void 0 ? void 0 : error.code) === TOGO_DELIVERY_SUBMIT_ORDER_ERROR_CODES.DELIVERY_ERROR_QUIT_FLOW)) {
                  _context24.next = 37;
                  break;
                }

                this.appMessages.showError(i18next.t("text.checkout.togoDelivery_updateDeliveryError_noRetry.title", {
                  defaultValue: "Oops!"
                }), i18next.t("text.checkout.togoDelivery_updateDeliveryError_noRetry.subMessage", {
                  defaultValue: "We have hit an unexpected error. Please click on OK to proceed further."
                }), null, {
                  undismissible: true,
                  okBtnText: i18next.t("text.checkout.togoDelivery_updateDeliveryError_noRetry.ctaLabel", {
                    defaultValue: "Ok"
                  }),
                  okBtnOnClick: function okBtnOnClick() {
                    _this13.updateDeliveryCookieAndRedirectToMenu();
                  }
                });
                return _context24.abrupt("return", result);

              case 37:
                _context24.t0 = error === null || error === void 0 ? void 0 : error.code;
                _context24.next = _context24.t0 === "OrderService-800" ? 40 : _context24.t0 === "OrderService-801" ? 40 : _context24.t0 === "OrderService-601" ? 43 : _context24.t0 === "OrderService-602" ? 43 : _context24.t0 === "OrderService-603" ? 43 : _context24.t0 === "OrderService-605" ? 43 : _context24.t0 === "OrderService-606" ? 43 : _context24.t0 === "OrderService-608" ? 43 : _context24.t0 === "DRI-580" ? 43 : _context24.t0 === "CRT415" ? 43 : _context24.t0 === "CRT430" ? 43 : _context24.t0 === "CRT431" ? 43 : _context24.t0 === "CRT432" ? 43 : _context24.t0 === "CRT433" ? 43 : _context24.t0 === "CRT434" ? 43 : _context24.t0 === "CRT435" ? 43 : _context24.t0 === "CRT436" ? 43 : _context24.t0 === "CRT437" ? 43 : _context24.t0 === "CRT438" ? 43 : _context24.t0 === "CRT440" ? 43 : _context24.t0 === "CRT445" ? 43 : _context24.t0 === "CRT464" ? 43 : _context24.t0 === "CRT465" ? 43 : _context24.t0 === "CRT466" ? 43 : _context24.t0 === "CRT467" ? 43 : _context24.t0 === "CRT468" ? 43 : _context24.t0 === "CRT469" ? 43 : _context24.t0 === "otherExceptions" ? 43 : 46;
                break;

              case 40:
                _context24.next = 42;
                return this.capacityErrorHandle().then(function () {
                  result.faultCode = "CAPACITY_ERROR";
                }, function () {
                  var _this13$appMessages;

                  _this13.dialogueCode = CheckoutDialogueCodes.ERROR_CASE_MISSING;
                  result.faultCode = "ORDER_PROCESSING_ERROR";
                  (_this13$appMessages = _this13.appMessages) === null || _this13$appMessages === void 0 ? void 0 : _this13$appMessages.showError("Oops! Something went wrong...", error === null || error === void 0 ? void 0 : error.message);
                });

              case 42:
                return _context24.abrupt("break", 48);

              case 43:
                result.faultCode = error === null || error === void 0 ? void 0 : error.code;
                this.appMessages.showError("Error", error === null || error === void 0 ? void 0 : error.message);
                return _context24.abrupt("break", 48);

              case 46:
                result.faultCode = (error === null || error === void 0 ? void 0 : error.code) || "ORDER_PROCESSING_ERROR";
                this.appMessages.showError("Error", isTOGODelivery && error !== null && error !== void 0 && error.message.length ? error === null || error === void 0 ? void 0 : error.message : "Unable to proceed with order submission. Please try again.");

              case 48:
                return _context24.abrupt("return", result);

              case 49:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24, this);
      }));

      function parseSubmitOrderAPIErrors(_x15) {
        return _parseSubmitOrderAPIErrors.apply(this, arguments);
      }

      return parseSubmitOrderAPIErrors;
    }()
  }, {
    key: "analyticsFailedSubmitOrderEvent",
    value: function analyticsFailedSubmitOrderEvent() {
      this.rootStore.platformUtil.dispatchEvent("AnalyticsEvent", "Payment", {
        success: false
      });
    }
  }, {
    key: "analyticsEclubCheck",
    value: function analyticsEclubCheck() {
      var _this$rootStore10, _this$rootStore10$com, _this$rootStore10$com2, _this$rootStore10$com3, _signUpSources, _signUpSources$findIn, _signUpSources2, _signUpSources2$signU;

      var signUpSources = [];

      if (this !== null && this !== void 0 && (_this$rootStore10 = this.rootStore) !== null && _this$rootStore10 !== void 0 && (_this$rootStore10$com = _this$rootStore10.common) !== null && _this$rootStore10$com !== void 0 && (_this$rootStore10$com2 = _this$rootStore10$com.appAttributes) !== null && _this$rootStore10$com2 !== void 0 && (_this$rootStore10$com3 = _this$rootStore10$com2.configs) !== null && _this$rootStore10$com3 !== void 0 && _this$rootStore10$com3.signUpSources) {
        var _this$rootStore11, _this$rootStore11$com, _this$rootStore11$com2, _this$rootStore11$com3;

        signUpSources = JSON.parse(this === null || this === void 0 ? void 0 : (_this$rootStore11 = this.rootStore) === null || _this$rootStore11 === void 0 ? void 0 : (_this$rootStore11$com = _this$rootStore11.common) === null || _this$rootStore11$com === void 0 ? void 0 : (_this$rootStore11$com2 = _this$rootStore11$com.appAttributes) === null || _this$rootStore11$com2 === void 0 ? void 0 : (_this$rootStore11$com3 = _this$rootStore11$com2.configs) === null || _this$rootStore11$com3 === void 0 ? void 0 : _this$rootStore11$com3.signUpSources);
      }

      var platformType = this.rootStore.platformUtil.PLATFORM_TYPE;
      var signUpSourceIndex = (_signUpSources = signUpSources) === null || _signUpSources === void 0 ? void 0 : (_signUpSources$findIn = _signUpSources.findIndex) === null || _signUpSources$findIn === void 0 ? void 0 : _signUpSources$findIn.call(_signUpSources, function (item) {
        return item.page === "ToGo Order" && item.channel === platformType;
      });
      var concept = this.appAttributes.concept.conceptCode;
      this.rootStore.platformUtil.dispatchEvent("AnalyticsForm", "eClubOptinComplete", {
        brands: [concept],
        signupChannel: signUpSourceIndex !== -1 ? (_signUpSources2 = signUpSources) === null || _signUpSources2 === void 0 ? void 0 : (_signUpSources2$signU = _signUpSources2[signUpSourceIndex]) === null || _signUpSources2$signU === void 0 ? void 0 : _signUpSources2$signU.signupSource : "".concat(concept, "_").concat(platformType === "APP" ? "mapp" : "signup", "_to_go_order")
      });
    }
  }, {
    key: "redirectToConfirmationPage",
    value: function redirectToConfirmationPage(orderId) {
      var _this14 = this;

      this.rootStore.platformUtil.clearSessionStorage()["finally"](function () {
        if (_this14.rootStore.platformUtil.PLATFORM_TYPE === "APP") {
          var _this14$rootStore, _this14$rootStore$pla;

          (_this14$rootStore = _this14.rootStore) === null || _this14$rootStore === void 0 ? void 0 : (_this14$rootStore$pla = _this14$rootStore.platformUtil) === null || _this14$rootStore$pla === void 0 ? void 0 : _this14$rootStore$pla.navigateToRoute("/commerce/order-confirmation", [{
            name: "orderId",
            value: orderId
          }]);
        }

        _this14.rootStore.platformUtil.redirectToURL("/commerce/order-confirmation?orderId=".concat(orderId));
      });
    }
  }, {
    key: "redirectToEmptyCartPage",
    value: function redirectToEmptyCartPage() {
      if (this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.WEB) {
        var _this$checkoutAttribu4;

        if ((_this$checkoutAttribu4 = this.checkoutAttributes) !== null && _this$checkoutAttribu4 !== void 0 && _this$checkoutAttribu4.cartEmptyURL) {
          this.rootStore.platformUtil.redirectToURL(this.checkoutAttributes.cartEmptyURL);
        } else {
          // this.rootStore.refreshInProgress = true;
          this.rootStore.platformUtil.redirectToURL("/order-online?cartEmpty=true");
        }
      } else {
        this.rootStore.reloadApp();
      }
    }
  }, {
    key: "fetchTimes",
    value: function () {
      var _fetchTimes = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var _this$rootStore$user$3,
            _this15 = this;

        var realtime,
            selectedDate,
            from,
            orderContext,
            _this$rootStore12,
            _this$rootStore12$use,
            _this$rootStore13,
            _this$rootStore13$use,
            _this$rootStore13$use2,
            _this$rootStore13$use3,
            orderType,
            JWT_TOKEN,
            _yield$handle17,
            _yield$handle18,
            timesResponse,
            _args25 = arguments;

        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                realtime = _args25.length > 0 && _args25[0] !== undefined ? _args25[0] : false;
                selectedDate = _args25.length > 1 ? _args25[1] : undefined;
                from = _args25.length > 2 ? _args25[2] : undefined;
                orderContext = (_this$rootStore$user$3 = this.rootStore.user.sessionDetails) === null || _this$rootStore$user$3 === void 0 ? void 0 : _this$rootStore$user$3.orderContext;

                if (!orderContext) {
                  _context25.next = 22;
                  break;
                }

                _context25.prev = 5;
                orderType = orderContext.orderTypeValue; // if the user is currently on the delivery flow and we want to switch it to noraml pickup
                // then we'll set the orderType as 0

                if (from === FETCH_TIME_TYPE.PICKUP_SWITCH) {
                  orderType = 0;
                }

                _context25.next = 10;
                return (_this$rootStore12 = this.rootStore) === null || _this$rootStore12 === void 0 ? void 0 : (_this$rootStore12$use = _this$rootStore12.user) === null || _this$rootStore12$use === void 0 ? void 0 : _this$rootStore12$use.getTokenSilentIfLoggedIn();

              case 10:
                JWT_TOKEN = _context25.sent;
                _context25.next = 13;
                return handle(DPServices.Times.getPickupTimes(JWT_TOKEN, this === null || this === void 0 ? void 0 : (_this$rootStore13 = this.rootStore) === null || _this$rootStore13 === void 0 ? void 0 : (_this$rootStore13$use = _this$rootStore13.user) === null || _this$rootStore13$use === void 0 ? void 0 : (_this$rootStore13$use2 = _this$rootStore13$use.sessionDetails) === null || _this$rootStore13$use2 === void 0 ? void 0 : (_this$rootStore13$use3 = _this$rootStore13$use2.restaurantDetails) === null || _this$rootStore13$use3 === void 0 ? void 0 : _this$rootStore13$use3.restaurantNumber, selectedDate || this.timeModel.selectedCalendarDate, orderType, realtime));

              case 13:
                _yield$handle17 = _context25.sent;
                _yield$handle18 = _slicedToArray(_yield$handle17, 2);
                timesResponse = _yield$handle18[1];

                if (timesResponse) {
                  runInAction(function () {
                    var _this15$timeModel, _this15$timeModel$sel;

                    _this15.timeModel.currentRequestedDate = (_this15$timeModel = _this15.timeModel) === null || _this15$timeModel === void 0 ? void 0 : (_this15$timeModel$sel = _this15$timeModel.selectedCalendarDate) === null || _this15$timeModel$sel === void 0 ? void 0 : _this15$timeModel$sel.getTime();

                    _this15.timeModel.setCapacitySlotsResponse(timesResponse);
                  });
                }

                _context25.next = 22;
                break;

              case 19:
                _context25.prev = 19;
                _context25.t0 = _context25["catch"](5);
                this.appMessages.showError("Error", "Error Fetching Time Slots.");

              case 22:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25, this, [[5, 19]]);
      }));

      function fetchTimes() {
        return _fetchTimes.apply(this, arguments);
      }

      return fetchTimes;
    }()
    /**
     *
     * @param forceSwitchToScheduledFromASAP default false. Pass true to make pickupTime call with asap false
     * overriding previous asapSelected choice
     */

  }, {
    key: "setNewPickupTime",
    value: function () {
      var _setNewPickupTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var _this16 = this;

        var forceSwitchToScheduledFromASAP,
            startTime,
            _this$rootStore$user2,
            _this$rootStore14,
            _this$rootStore14$com,
            newSelectedTime,
            token,
            isAsapSelected,
            setPickupResponse,
            _this$rootStore15,
            _this$rootStore15$use,
            jwt,
            _args26 = arguments;

        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                forceSwitchToScheduledFromASAP = _args26.length > 0 && _args26[0] !== undefined ? _args26[0] : false;
                startTime = _args26.length > 1 ? _args26[1] : undefined;
                _context26.prev = 2;
                newSelectedTime = startTime || this.timeModel.currentTimeSlot.startTimeInMs;
                _context26.next = 6;
                return (_this$rootStore$user2 = this.rootStore.user) === null || _this$rootStore$user2 === void 0 ? void 0 : _this$rootStore$user2.getTokenSilentIfLoggedIn();

              case 6:
                token = _context26.sent; // forceSwitchToScheduledFromASAP is true then send asapSelected as false.

                isAsapSelected = forceSwitchToScheduledFromASAP ? false : this.timeModel.isAsapSelected;
                _context26.next = 10;
                return DPServices.Times.setOrderPickupTime(moment(newSelectedTime).toDate(), (_this$rootStore14 = this.rootStore) === null || _this$rootStore14 === void 0 ? void 0 : (_this$rootStore14$com = _this$rootStore14.common) === null || _this$rootStore14$com === void 0 ? void 0 : _this$rootStore14$com.orderID, token, isAsapSelected);

              case 10:
                setPickupResponse = _context26.sent;
                runInAction(function () {
                  var _this16$timeModel;

                  _this16.timeModel.setTimeModalShown(false);

                  _this16.timeModel.setPickupTimeResponse(setPickupResponse);

                  (_this16$timeModel = _this16.timeModel) === null || _this16$timeModel === void 0 ? void 0 : _this16$timeModel.setRecentTimeSelectionFromAPi(UserTypes.ERecentTimeSelectionFromAPI.SET_PICKUP_TIME_API);

                  _this16.carSideApiHandler();

                  if (!_this16.timeModel.isCapacityError) {
                    _this16.determinePaymentMethods();
                  }
                });
                return _context26.abrupt("return", true);

              case 15:
                _context26.prev = 15;
                _context26.t0 = _context26["catch"](2);
                this.unavailableItemsModel.submitErrorHandler(_context26.t0);
                _context26.next = 20;
                return (_this$rootStore15 = this.rootStore) === null || _this$rootStore15 === void 0 ? void 0 : (_this$rootStore15$use = _this$rootStore15.user) === null || _this$rootStore15$use === void 0 ? void 0 : _this$rootStore15$use.getTokenSilentIfLoggedIn();

              case 20:
                jwt = _context26.sent;

                this._handleOrderPickupTimeError(_context26.t0, jwt);

              case 22:
                return _context26.abrupt("return", false);

              case 23:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this, [[2, 15]]);
      }));

      function setNewPickupTime() {
        return _setNewPickupTime.apply(this, arguments);
      }

      return setNewPickupTime;
    }()
  }, {
    key: "resubmitOrderFromCapacityError",
    value: function () {
      var _resubmitOrderFromCapacityError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var success;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                if (!this.timeModel.isValid) {
                  _context27.next = 7;
                  break;
                }

                _context27.next = 3;
                return this.setNewPickupTime(true);

              case 3:
                success = _context27.sent;

                if (success) {
                  this.submitOrder(true);
                }

                _context27.next = 8;
                break;

              case 7:
                this.timeModel.handleInvalidModel(this.appMessages);

              case 8:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this);
      }));

      function resubmitOrderFromCapacityError() {
        return _resubmitOrderFromCapacityError.apply(this, arguments);
      }

      return resubmitOrderFromCapacityError;
    }()
  }, {
    key: "cancelCapacityError",
    value: function () {
      var _cancelCapacityError = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
        var _this17 = this;

        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                runInAction( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
                  return _regeneratorRuntime.wrap(function _callee28$(_context28) {
                    while (1) {
                      switch (_context28.prev = _context28.next) {
                        case 0:
                          _this17.timeModel.isCapacityError = true; //??

                          _this17.timeModel.setTimeModalShown(false);

                          _this17.timeModel.isCapacityError = false;

                        /** ----------------------------------------------
                         * COMMENTING OUT THIS CODE AS setNewPickupTime WILL BE CALLED AS SOON AS CapacityError OCCUR
                         * INSTEAD OF CALLING ON POPUP CLOSE, CANCAL ACTION
                         * ----------------------------------------------
                         */
                        // In case of capacity error send asapSelected false to force switch to scheduled time
                        // const success = await this.setNewPickupTime(true);
                        // const message = this.timeModel.isAsapSelected
                        //   ? i18next.t(
                        //       "text.checkout.cancelCapacityErrorASAP.success.successMessage",
                        //       {
                        //         defaultValue: `Your ASAP time has been updated to ${this.timeModel.displayDate}.`,
                        //         interpolation: { prefix: "${", suffix: "}" },
                        //         0: this.timeModel.displayDate,
                        //       },
                        //     )
                        //   : i18next.t(
                        //       "text.checkout.cancelCapacityError.success.successMessage",
                        //       {
                        //         defaultValue: `Your pickup time has been updated to first available slot.`,
                        //       },
                        //     );
                        // if (success) {
                        //   this.appMessages.showSuccess("Pickup time updated.", message);
                        //   this.determinePaymentMethods();
                        //   this.timeModel.isCapacityError = false;
                        // } else {
                        //   this.appMessages.showError(
                        //     "Pickup time",
                        //     "Failed to update pickup time.",
                        //   );
                        // } 

                        case 3:
                        case "end":
                          return _context28.stop();
                      }
                    }
                  }, _callee28);
                })));

              case 1:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));

      function cancelCapacityError() {
        return _cancelCapacityError.apply(this, arguments);
      }

      return cancelCapacityError;
    }()
  }, {
    key: "carSideApiHandler",
    value: function () {
      var _carSideApiHandler = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        var _this$rootStore16, _this$rootStore16$use, _this$cartOrder4;

        var _this$checkoutAttribu5, isInRestaurantPickupAvailable, isCurbsideNotificationEnabled, JWT_TOKEN, carSidePickupAvailable;

        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                _this$checkoutAttribu5 = this.checkoutAttributes, isInRestaurantPickupAvailable = _this$checkoutAttribu5.isInRestaurantPickupAvailable, isCurbsideNotificationEnabled = _this$checkoutAttribu5.isCurbsideNotificationEnabled;
                _context30.next = 3;
                return (_this$rootStore16 = this.rootStore) === null || _this$rootStore16 === void 0 ? void 0 : (_this$rootStore16$use = _this$rootStore16.user) === null || _this$rootStore16$use === void 0 ? void 0 : _this$rootStore16$use.getTokenSilentIfLoggedIn();

              case 3:
                JWT_TOKEN = _context30.sent;
                _context30.next = 6;
                return DPServices.Restaurant.checkCarsideAvailable((_this$cartOrder4 = this.cartOrder) === null || _this$cartOrder4 === void 0 ? void 0 : _this$cartOrder4.orderId, JWT_TOKEN);

              case 6:
                carSidePickupAvailable = _context30.sent;
                this.handleCurbsideAvailability(carSidePickupAvailable, isInRestaurantPickupAvailable, isCurbsideNotificationEnabled);

              case 8:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, this);
      }));

      function carSideApiHandler() {
        return _carSideApiHandler.apply(this, arguments);
      }

      return carSideApiHandler;
    }()
  }, {
    key: "handleCurbsideAvailability",
    value: function handleCurbsideAvailability(isCurbSideToGoAvailable, isInRestaurantPickupAvailable, isCurbsideNotificationEnabled) {
      if (isCurbSideToGoAvailable && isInRestaurantPickupAvailable) {
        // BOTH Available
        this.pickupInfoModel.inRestaurantPickupAvailable = true;
        this.pickupInfoModel.carSidePickupAvailable = true;

        if (!this.pickupMethodModel.pickupMethod) {
          this.pickupMethodModel.pickupMethod = PickupMethod.CARSIDE; // Default to Curbside
        }

        isCurbsideNotificationEnabled ? this.pickupInfoModel.isCurbsideNotificationEnabled = true : this.pickupInfoModel.isCurbsideNotificationEnabled = false;
      } else {
        // Only One Available
        if (isCurbSideToGoAvailable) {
          this.pickupInfoModel.inRestaurantPickupAvailable = false;
          this.pickupMethodModel.pickupMethod = PickupMethod.CARSIDE; // Default to Curbside

          this.pickupInfoModel.carSidePickupAvailable = true;
          isCurbsideNotificationEnabled ? this.pickupInfoModel.isCurbsideNotificationEnabled = true : this.pickupInfoModel.isCurbsideNotificationEnabled = false;
        } else {
          this.pickupInfoModel.inRestaurantPickupAvailable = true;
          this.pickupMethodModel.pickupMethod = PickupMethod.IN_RESTAURANT; // Default to In Restaurant

          this.pickupInfoModel.carSidePickupAvailable = false;
        }
      }
    } //Capacity error handler function

  }, {
    key: "capacityErrorHandle",
    value: function () {
      var _capacityErrorHandle = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
        var _this$timeModel$avail;

        var _nextAvailableSlot, nextAvailableSlot;

        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                _context31.next = 2;
                return this.fetchTimes(true);

              case 2:
                if (!(this.cartOrder.orderType === ORDER_TYPES.TOGO_DELIVERY)) {
                  _context31.next = 8;
                  break;
                }

                this.timeModel.setIsTOGODeliveryCapacityError(true);
                _nextAvailableSlot = this.timeModel.availableSlots[0];
                this.timeModel.selectedTimeSlotFromDD = _nextAvailableSlot;
                this.appMessages.showError(i18next.t("error.togoDelivery_checkout.capacityError_titleText", {
                  defaultValue: "Delivery Time Update"
                }), i18next.t("error.togoDelivery_checkout.capacityError_bodyText", {
                  defaultValue: 'The estimated delivery time has changed. Please select "place order" to receive an updated delivery time.'
                }), null, {
                  undismissible: false,
                  okBtnText: "OK"
                });
                return _context31.abrupt("return");

              case 8:
                this.timeModel.isCapacityError = true; // set first available slot as new pickup time with ASAP as false.

                nextAvailableSlot = (_this$timeModel$avail = this.timeModel.availableSlots) === null || _this$timeModel$avail === void 0 ? void 0 : _this$timeModel$avail[0];

                if (!(nextAvailableSlot !== null && nextAvailableSlot !== void 0 && nextAvailableSlot.startTimeInMs)) {
                  _context31.next = 14;
                  break;
                }

                this.timeModel.selectedTimeSlotFromDD = nextAvailableSlot;
                _context31.next = 14;
                return this.setNewPickupTime(true);

              case 14:
                this.timeModel.setTimeModalShown(true);
              //dont change order of setters(), popuup should show after turning capacity on

              case 15:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31, this);
      }));

      function capacityErrorHandle() {
        return _capacityErrorHandle.apply(this, arguments);
      }

      return capacityErrorHandle;
    }()
  }, {
    key: "cleanupAfterCheckoutSucess",
    value: function () {
      var _cleanupAfterCheckoutSucess = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        var _this$rootStore17, _this$rootStore17$pla, _this$rootStore18, _this$rootStore18$men, _this$rootStore18$men2;

        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                _context32.prev = 0;
                _context32.next = 3;
                return this.rootStore.platformUtil.clearLocalStorage(["ORDER_HISTORY", "FAVORITE_PRODUCTS", "PROFILE_ORDER_HISTORY"]);

              case 3:
                _context32.next = 5;
                return (_this$rootStore17 = this.rootStore) === null || _this$rootStore17 === void 0 ? void 0 : (_this$rootStore17$pla = _this$rootStore17.platformUtil) === null || _this$rootStore17$pla === void 0 ? void 0 : _this$rootStore17$pla.saveInSessionStorage("UPSELL_CHECKOUT_CONFIRMATION", "false");

              case 5:
                if (!(this.rootStore.platformUtil.PLATFORM_TYPE === PlatformType.APP)) {
                  _context32.next = 15;
                  break;
                }

                _context32.next = 8;
                return this.rootStore.user.updateSession();

              case 8:
                _context32.next = 10;
                return this.rootStore.payment.init();

              case 10:
                _context32.next = 12;
                return this.rootStore.menuList.init();

              case 12:
                this === null || this === void 0 ? void 0 : (_this$rootStore18 = this.rootStore) === null || _this$rootStore18 === void 0 ? void 0 : (_this$rootStore18$men = _this$rootStore18.menuList) === null || _this$rootStore18$men === void 0 ? void 0 : (_this$rootStore18$men2 = _this$rootStore18$men.cartModel) === null || _this$rootStore18$men2 === void 0 ? void 0 : _this$rootStore18$men2.setCartData(null);
                this.rootStore.menuList.breadSticksModel.cartItems = null; // Once Order is placed remove orderID for store.

                this.rootStore.common.orderID = null;

              case 15:
                _context32.next = 19;
                break;

              case 17:
                _context32.prev = 17;
                _context32.t0 = _context32["catch"](0);

              case 19:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, this, [[0, 17]]);
      }));

      function cleanupAfterCheckoutSucess() {
        return _cleanupAfterCheckoutSucess.apply(this, arguments);
      }

      return cleanupAfterCheckoutSucess;
    }()
  }, {
    key: "rateUserVisit",
    value: function () {
      var _rateUserVisit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(params) {
        var _DPServices$User, _yield$handle19, _yield$handle20, err, visitResponse, _DPServices$Cart$pars, errObj, faults, haveErrorDescription;

        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.prev = 0;
                _context33.next = 3;
                return handle(DPServices === null || DPServices === void 0 ? void 0 : (_DPServices$User = DPServices.User) === null || _DPServices$User === void 0 ? void 0 : _DPServices$User.rateVisit(params));

              case 3:
                _yield$handle19 = _context33.sent;
                _yield$handle20 = _slicedToArray(_yield$handle19, 2);
                err = _yield$handle20[0];
                visitResponse = _yield$handle20[1];

                if (!err) {
                  _context33.next = 16;
                  break;
                }

                errObj = err;
                faults = (_DPServices$Cart$pars = DPServices.Cart.parseErrors(errObj)) === null || _DPServices$Cart$pars === void 0 ? void 0 : _DPServices$Cart$pars.faults;
                haveErrorDescription = faults && faults[0] && faults[0].faultDescription;

                if (!haveErrorDescription) {
                  _context33.next = 15;
                  break;
                }

                throw new Error(haveErrorDescription);

              case 15:
                throw Errors.RATE_USER_VISIT_FAILED;

              case 16:
                return _context33.abrupt("return", visitResponse === null || visitResponse === void 0 ? void 0 : visitResponse.feedbackSubmit);

              case 19:
                _context33.prev = 19;
                _context33.t0 = _context33["catch"](0);
                this.rootStore.appMessages.showError(ERROR_STRINGS.SORRY_SOMETHING_WENT_WRONG, _context33.t0.message);
                return _context33.abrupt("return", false);

              case 23:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33, this, [[0, 19]]);
      }));

      function rateUserVisit(_x16) {
        return _rateUserVisit.apply(this, arguments);
      }

      return rateUserVisit;
    }()
  }, {
    key: "saveOrderDataInLocalStorage",
    value: function () {
      var _saveOrderDataInLocalStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(orderID, custEmail, orderTime) {
        var temp, updatedData, storedData, _this$rootStore19, _this$rootStore19$men, thresholdTimestamp, updatedDataAfterTimeValidation;

        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                temp = {
                  id: orderID,
                  emailId: custEmail,
                  orderTime: orderTime
                };
                updatedData = [];
                _context34.next = 4;
                return this.rootStore.platformUtil.getFromLocalStorage("RECENT_ORDER_DETAILS").then(JSON.parse);

              case 4:
                storedData = _context34.sent;

                if (storedData) {
                  updatedData = [].concat(_toConsumableArray(storedData), [temp]);
                } else {
                  updatedData = [temp];
                }

                _context34.prev = 6;
                thresholdTimestamp = moment().subtract(6, "months").valueOf();
                updatedDataAfterTimeValidation = updatedData.filter(function (_data) {
                  var orderTimeStamp = _data.orderTime;
                  return orderTimeStamp > thresholdTimestamp;
                });
                _context34.next = 11;
                return this.rootStore.platformUtil.saveInLocalStorage("RECENT_ORDER_DETAILS", JSON.stringify(updatedDataAfterTimeValidation));

              case 11:
                _context34.next = 13;
                return (_this$rootStore19 = this.rootStore) === null || _this$rootStore19 === void 0 ? void 0 : (_this$rootStore19$men = _this$rootStore19.menuList) === null || _this$rootStore19$men === void 0 ? void 0 : _this$rootStore19$men.fetchRecentOrdersFromLocalStorage();

              case 13:
                _context34.next = 18;
                break;

              case 15:
                _context34.prev = 15;
                _context34.t0 = _context34["catch"](6);
                console.log("*** catch", _context34.t0);

              case 18:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, this, [[6, 15]]);
      }));

      function saveOrderDataInLocalStorage(_x17, _x18, _x19) {
        return _saveOrderDataInLocalStorage.apply(this, arguments);
      }

      return saveOrderDataInLocalStorage;
    }()
  }, {
    key: "createGeoFence",
    value: function () {
      var _createGeoFence = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(posCheckReference, orderId, email) {
        var _this$rootStore20, _this$rootStore20$res, _this$rootStore20$res2, _this$rootStore20$res3;

        var curbsideTogo, _this$rootStore21, _this$rootStore$resta, _this$rootStore$resta2, _this$rootStore$resta3, _this$rootStore$resta4, _this$rootStore$resta5, _this$rootStore$resta6, _this$rootStore$resta7, _this$rootStore$resta8, _this$rootStore$resta9, _this$rootStore$resta10, _this$cartOrder5, _this$rootStore22, _this$rootStore22$res, _this$rootStore22$res2, latitude, longitude, enableGeoFence, geoFenceLocationRadius, geofences, canGeoFence, isGeoFenceCapable, isGeoFenceAlreadyStarted, isNotificationPermissionGranted, isBackgroundLocationPermisionsGranted;

        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                curbsideTogo = (_this$rootStore20 = this.rootStore) === null || _this$rootStore20 === void 0 ? void 0 : (_this$rootStore20$res = _this$rootStore20.restaurant) === null || _this$rootStore20$res === void 0 ? void 0 : (_this$rootStore20$res2 = _this$rootStore20$res.detail) === null || _this$rootStore20$res2 === void 0 ? void 0 : (_this$rootStore20$res3 = _this$rootStore20$res2.features) === null || _this$rootStore20$res3 === void 0 ? void 0 : _this$rootStore20$res3.curbSideTogoEnabled;

                if (!posCheckReference) {
                  _context35.next = 30;
                  break;
                }

                _context35.next = 4;
                return (_this$rootStore21 = this.rootStore) === null || _this$rootStore21 === void 0 ? void 0 : _this$rootStore21.platformUtil.saveInLocalStorage("POS_TOKEN", JSON.stringify({
                  checkReference: posCheckReference,
                  orderId: orderId,
                  email: email,
                  curbsideEnabled: curbsideTogo ? "true" : "false"
                }));

              case 4:
                latitude = (_this$rootStore$resta = this.rootStore.restaurant) === null || _this$rootStore$resta === void 0 ? void 0 : (_this$rootStore$resta2 = _this$rootStore$resta.detail) === null || _this$rootStore$resta2 === void 0 ? void 0 : (_this$rootStore$resta3 = _this$rootStore$resta2.contactDetail) === null || _this$rootStore$resta3 === void 0 ? void 0 : (_this$rootStore$resta4 = _this$rootStore$resta3.address) === null || _this$rootStore$resta4 === void 0 ? void 0 : (_this$rootStore$resta5 = _this$rootStore$resta4.coordinates) === null || _this$rootStore$resta5 === void 0 ? void 0 : _this$rootStore$resta5.latitude;
                longitude = (_this$rootStore$resta6 = this.rootStore.restaurant) === null || _this$rootStore$resta6 === void 0 ? void 0 : (_this$rootStore$resta7 = _this$rootStore$resta6.detail) === null || _this$rootStore$resta7 === void 0 ? void 0 : (_this$rootStore$resta8 = _this$rootStore$resta7.contactDetail) === null || _this$rootStore$resta8 === void 0 ? void 0 : (_this$rootStore$resta9 = _this$rootStore$resta8.address) === null || _this$rootStore$resta9 === void 0 ? void 0 : (_this$rootStore$resta10 = _this$rootStore$resta9.coordinates) === null || _this$rootStore$resta10 === void 0 ? void 0 : _this$rootStore$resta10.longitude;
                enableGeoFence = this.rootStore.menuList.enableGeoFence;
                geoFenceLocationRadius = this.rootStore.menuList.geoFenceLocationRadius;
                geofences = [{
                  latitude: Number(latitude),
                  longitude: Number(longitude),
                  radius: geoFenceLocationRadius,
                  identifier: "".concat((_this$cartOrder5 = this.cartOrder) === null || _this$cartOrder5 === void 0 ? void 0 : _this$cartOrder5.orderId, ":").concat((_this$rootStore22 = this.rootStore) === null || _this$rootStore22 === void 0 ? void 0 : (_this$rootStore22$res = _this$rootStore22.restaurant) === null || _this$rootStore22$res === void 0 ? void 0 : (_this$rootStore22$res2 = _this$rootStore22$res.detail) === null || _this$rootStore22$res2 === void 0 ? void 0 : _this$rootStore22$res2.atgRestaurantId)
                }];
                canGeoFence = latitude && longitude && enableGeoFence && curbsideTogo && geoFenceLocationRadius;

                if (!canGeoFence) {
                  _context35.next = 28;
                  break;
                }

                _context35.next = 13;
                return this.rootStore.platformUtil.isGeoFenceCapable();

              case 13:
                isGeoFenceCapable = _context35.sent;
                _context35.next = 16;
                return this.rootStore.platformUtil.isGeoFenceStarted();

              case 16:
                isGeoFenceAlreadyStarted = _context35.sent;
                isNotificationPermissionGranted = this.rootStore.user.pushNotificationPermissionGranted;
                isBackgroundLocationPermisionsGranted = this.rootStore.user.backgroundLocationPermissionGranted;

                if (!(isGeoFenceCapable && isNotificationPermissionGranted && isBackgroundLocationPermisionsGranted)) {
                  _context35.next = 27;
                  break;
                }

                if (!isGeoFenceAlreadyStarted) {
                  _context35.next = 23;
                  break;
                }

                _context35.next = 23;
                return this.rootStore.platformUtil.stopGeoFence();

              case 23:
                _context35.next = 25;
                return this.rootStore.platformUtil.startGeoFence(geofences[0]);

              case 25:
                _context35.next = 28;
                break;

              case 27:
                this.rootStore.showLocationPermissionPopup = true;

              case 28:
                _context35.next = 34;
                break;

              case 30:
                _context35.next = 32;
                return this.rootStore.platformUtil.removeFromLocalStorage("POS_TOKEN");

              case 32:
                _context35.next = 34;
                return this.rootStore.platformUtil.stopGeoFence();

              case 34:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));

      function createGeoFence(_x20, _x21, _x22) {
        return _createGeoFence.apply(this, arguments);
      }

      return createGeoFence;
    }()
  }, {
    key: "dispatchCheckoutEvent",
    value: function dispatchCheckoutEvent() {
      var _this$cartOrder6;

      var cartId = (_this$cartOrder6 = this.cartOrder) === null || _this$cartOrder6 === void 0 ? void 0 : _this$cartOrder6.orderId;
      var payload = {
        "&&events": "event166:".concat(cartId)
      };
      this.analyticsModel.dispatchCheckoutEvent(payload);
    }
  }, {
    key: "_handleOrderPickupTimeError",
    value: function _handleOrderPickupTimeError(errorResponse, token) {
      var _this$timeModel,
          _this$rootStore23,
          _this$rootStore23$pla,
          _this18 = this;

      var error = errorResponse === null || errorResponse === void 0 ? void 0 : errorResponse.errors[0];
      var unavailableItems = error === null || error === void 0 ? void 0 : error.unavailableItems;
      (_this$timeModel = this.timeModel) === null || _this$timeModel === void 0 ? void 0 : _this$timeModel.setTimeModalShown(false);

      if (unavailableItems && Array.isArray(unavailableItems) && (unavailableItems === null || unavailableItems === void 0 ? void 0 : unavailableItems.length) > 0 && ((_this$rootStore23 = this.rootStore) === null || _this$rootStore23 === void 0 ? void 0 : (_this$rootStore23$pla = _this$rootStore23.platformUtil) === null || _this$rootStore23$pla === void 0 ? void 0 : _this$rootStore23$pla.PLATFORM_TYPE) === PlatformType.WEB) {
        var labels = [];
        unavailableItems === null || unavailableItems === void 0 ? void 0 : unavailableItems.forEach(function (_i) {
          labels.push(_i === null || _i === void 0 ? void 0 : _i.displayName);
        });
        var htmlText = getUnavailableItemsForError(unavailableItems);
        this.appMessages.showError("Item(s) Not Available.", i18next.t("error.items_not_available_info_checkout", {
          defaultValue: "Sorry! One or more items in your order are currently unavailable. If you continue, the following item(s) will be removed from your cart."
        }), labels, {
          undismissible: true,
          okBtnText: "Continue",
          showIconBox: false,
          isRichText: true,
          i18ResourceString: "error.items_not_available_info",
          normalHtml: htmlText,
          okBtnOnClick: function () {
            var _okBtnOnClick = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
              var _this18$timeModel$cur, _this18$rootStore, _this18$rootStore$com, _this18$timeModel, _this18$rootStore2, _this18$rootStore2$pl;

              var newSelectedTime, newSelectedTimeDate, orderId, promises;
              return _regeneratorRuntime.wrap(function _callee36$(_context36) {
                while (1) {
                  switch (_context36.prev = _context36.next) {
                    case 0:
                      newSelectedTime = (_this18$timeModel$cur = _this18.timeModel.currentTimeSlot) === null || _this18$timeModel$cur === void 0 ? void 0 : _this18$timeModel$cur.startTimeInMs;
                      newSelectedTimeDate = newSelectedTime ? moment(newSelectedTime).toDate() : moment().toDate();
                      orderId = (_this18$rootStore = _this18.rootStore) === null || _this18$rootStore === void 0 ? void 0 : (_this18$rootStore$com = _this18$rootStore.common) === null || _this18$rootStore$com === void 0 ? void 0 : _this18$rootStore$com.orderID;
                      promises = unavailableItems === null || unavailableItems === void 0 ? void 0 : unavailableItems.map(function (item) {
                        return DPServices.Cart.deleteItem(token, {
                          orderId: orderId,
                          commerceId: item.id
                        })["catch"](function (error) {//
                        });
                      });
                      _context36.next = 6;
                      return Promise.all(promises);

                    case 6:
                      _context36.next = 8;
                      return DPServices.Times.setOrderPickupTime(newSelectedTimeDate, orderId, token, newSelectedTime ? false : (_this18$timeModel = _this18.timeModel) === null || _this18$timeModel === void 0 ? void 0 : _this18$timeModel.isAsapSelected, true);

                    case 8:
                      (_this18$rootStore2 = _this18.rootStore) === null || _this18$rootStore2 === void 0 ? void 0 : (_this18$rootStore2$pl = _this18$rootStore2.platformUtil) === null || _this18$rootStore2$pl === void 0 ? void 0 : _this18$rootStore2$pl.redirectToURL("/menu");

                    case 9:
                    case "end":
                      return _context36.stop();
                  }
                }
              }, _callee36);
            }));

            function okBtnOnClick() {
              return _okBtnOnClick.apply(this, arguments);
            }

            return okBtnOnClick;
          }()
        });
      }

      if (error !== null && error !== void 0 && error.code) {
        //TODO:(Checkout Error):asap_not_available,asap_not_available_pickup
        this.appMessages.showError("Something Went Wrong", error === null || error === void 0 ? void 0 : error.message, null);
      }
    }
  }, {
    key: "updateDeliveryCookieAndRedirectToMenu",
    value: function () {
      var _updateDeliveryCookieAndRedirectToMenu = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
        var _this19 = this;

        var JWT_TOKEN, orderId;
        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.prev = 0;
                _context37.next = 3;
                return this.rootStore.user.getTokenSilentIfLoggedIn();

              case 3:
                JWT_TOKEN = _context37.sent;
                orderId = this.cartOrder.orderId;
                _context37.next = 7;
                return DPServices.Cart.updateDeliveryCookie(orderId, JWT_TOKEN).then(function (result) {
                  console.log("*#* update delivery cookie success :", result);
                })["catch"](function (error) {
                  console.log("*#* something went wrong with update delivery cookie: ", error);
                })["finally"](function () {
                  var _this19$rootStore, _this19$rootStore$pla;

                  (_this19$rootStore = _this19.rootStore) === null || _this19$rootStore === void 0 ? void 0 : (_this19$rootStore$pla = _this19$rootStore.platformUtil) === null || _this19$rootStore$pla === void 0 ? void 0 : _this19$rootStore$pla.redirectToURL("/menu");
                });

              case 7:
                _context37.next = 13;
                break;

              case 9:
                _context37.prev = 9;
                _context37.t0 = _context37["catch"](0); // this should never happen

                console.log(_context37.t0);
                this.appMessages.showError("Error", "Something went wrong, try again later.");

              case 13:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this, [[0, 9]]);
      }));

      function updateDeliveryCookieAndRedirectToMenu() {
        return _updateDeliveryCookieAndRedirectToMenu.apply(this, arguments);
      }

      return updateDeliveryCookieAndRedirectToMenu;
    }() // navigateToMenu param defaults to true.
    // When ever we switch types, we navigate user back to menu page after location time api call (switch api)

  }, {
    key: "deliveryToPickupSwitch",
    value: function () {
      var _deliveryToPickupSwitch = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        var navigateToMenu,
            _this$timeModel$avail2,
            startTime,
            _this$rootStore24,
            _this$rootStore24$use,
            _this$rootStore25,
            _this$rootStore25$use,
            newSelectedTimeDate,
            jwtToken,
            _this$rootStore26,
            _this$rootStore26$pla,
            _args38 = arguments;

        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                navigateToMenu = _args38.length > 0 && _args38[0] !== undefined ? _args38[0] : true;
                _context38.prev = 1;
                _context38.next = 4;
                return this.fetchTimes(false, moment().toDate(), FETCH_TIME_TYPE.PICKUP_SWITCH);

              case 4:
                startTime = (_this$timeModel$avail2 = this.timeModel.availableSlots[0]) === null || _this$timeModel$avail2 === void 0 ? void 0 : _this$timeModel$avail2.startTimeInMs;

                if (!startTime) {
                  _context38.next = 14;
                  break;
                }

                newSelectedTimeDate = moment(startTime).toDate();
                _context38.next = 9;
                return (_this$rootStore24 = this.rootStore) === null || _this$rootStore24 === void 0 ? void 0 : (_this$rootStore24$use = _this$rootStore24.user) === null || _this$rootStore24$use === void 0 ? void 0 : _this$rootStore24$use.getTokenSilentIfLoggedIn();

              case 9:
                jwtToken = _context38.sent;
                _context38.next = 12;
                return DPServices.Times.setOrderRestaurantAndPickupTime(newSelectedTimeDate, this.cartOrder.restaurantNum, this.cartOrder.orderId, jwtToken, false, false, this.cartOrder.orderType);

              case 12:
                _context38.next = 14;
                return (_this$rootStore25 = this.rootStore) === null || _this$rootStore25 === void 0 ? void 0 : (_this$rootStore25$use = _this$rootStore25.user) === null || _this$rootStore25$use === void 0 ? void 0 : _this$rootStore25$use.updateSession();

              case 14:
                if (navigateToMenu) {
                  (_this$rootStore26 = this.rootStore) === null || _this$rootStore26 === void 0 ? void 0 : (_this$rootStore26$pla = _this$rootStore26.platformUtil) === null || _this$rootStore26$pla === void 0 ? void 0 : _this$rootStore26$pla.navigateToRoute("/menu");
                }

                _context38.next = 20;
                break;

              case 17:
                _context38.prev = 17;
                _context38.t0 = _context38["catch"](1);
                console.log("**** Delivery to Pickup Switch Failed at Checkout ", _context38.t0);

              case 20:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this, [[1, 17]]);
      }));

      function deliveryToPickupSwitch() {
        return _deliveryToPickupSwitch.apply(this, arguments);
      }

      return deliveryToPickupSwitch;
    }()
  }, {
    key: "_handleCreateQuote",
    value: function () {
      var _handleCreateQuote2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
        var _this$timeModel2, _this$timeModel2$curr;

        var userChoice;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return this.createQuote(moment((_this$timeModel2 = this.timeModel) === null || _this$timeModel2 === void 0 ? void 0 : (_this$timeModel2$curr = _this$timeModel2.currentTimeSlot) === null || _this$timeModel2$curr === void 0 ? void 0 : _this$timeModel2$curr.startTimeInMs));

              case 2:
                userChoice = _context39.sent;
                return _context39.abrupt("return", userChoice);

              case 4:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, this);
      }));

      function _handleCreateQuote() {
        return _handleCreateQuote2.apply(this, arguments);
      }

      return _handleCreateQuote;
    }()
  }, {
    key: "isValid",
    get: function get() {
      var _this$cartOrder7;

      var orderInstructionModel = this.orderInstructionModel,
          pickupInfoModel = this.pickupInfoModel,
          payment = this.payment,
          contactInfoModel = this.contactInfoModel,
          ageConfirmModel = this.ageConfirmModel,
          timeModel = this.timeModel;
      return ageConfirmModel.isValid && payment.isValid && orderInstructionModel.isValid && pickupInfoModel.isValid && contactInfoModel.isValid && timeModel.isValid && (((_this$cartOrder7 = this.cartOrder) === null || _this$cartOrder7 === void 0 ? void 0 : _this$cartOrder7.orderType) === ORDER_TYPES.TOGO_DELIVERY ? this.formState._isQuoteValid : true);
    }
  }, {
    key: "isOrderDetailsValid",
    get: function get() {
      var orderInstructionModel = this.orderInstructionModel,
          pickupInfoModel = this.pickupInfoModel,
          timeModel = this.timeModel;
      return orderInstructionModel.isValid && pickupInfoModel.isValid && timeModel.isValid;
    }
  }, {
    key: "checkExpirationThreshold",
    get: function get() {
      var _this$appAttributes, _this$appAttributes$c, _this$appAttributes2, _this$appAttributes2$;

      return isTrue((_this$appAttributes = this.appAttributes) === null || _this$appAttributes === void 0 ? void 0 : (_this$appAttributes$c = _this$appAttributes.configs) === null || _this$appAttributes$c === void 0 ? void 0 : _this$appAttributes$c.checkExpirationThreshold, Number((_this$appAttributes2 = this.appAttributes) === null || _this$appAttributes2 === void 0 ? void 0 : (_this$appAttributes2$ = _this$appAttributes2.configs) === null || _this$appAttributes2$ === void 0 ? void 0 : _this$appAttributes2$.checkExpirationThreshold), 15);
    }
  }, {
    key: "dialogueCode",
    get: function get() {
      return this._dialogueCode;
    },
    set: function set(_dialogueCode) {
      var _this20 = this;

      runInAction(function () {
        _this20._dialogueCode = _dialogueCode;
      });
    }
  }]);

  return Checkout;
}(Base), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "cartOrder", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "formState", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "appAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "checkoutAttributes", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "result", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "setPickResult", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "_dialogueCode", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _applyDecoratedDescriptor(_class.prototype, "isValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "isOrderDetailsValid", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "isOrderDetailsValid"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "checkExpirationThreshold", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "checkExpirationThreshold"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleCurbsideAvailability", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleCurbsideAvailability"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "dialogueCode", [computed], Object.getOwnPropertyDescriptor(_class.prototype, "dialogueCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "deliveryToPickupSwitch", [action], Object.getOwnPropertyDescriptor(_class.prototype, "deliveryToPickupSwitch"), _class.prototype)), _class);
export { Checkout as default };